import * as read_api from "./alan_api";
function serialize_ancestor_named_object_path($_ancestor_named_object_path: read_api.Cancestor_named_object_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_ancestor_named_object_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__ancestor_named_object_path = $_ancestor_named_object_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__ancestor_named_object_path = $_ancestor_named_object_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_ancestor_named_object_path($_yes__has_steps__ancestor_named_object_path.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ancestor_named_object_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_ancestor_named_object_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_ancestor_node_path($_ancestor_node_path: read_api.Cancestor_node_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_ancestor_node_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__ancestor_node_path = $_ancestor_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__ancestor_node_path = $_ancestor_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_ancestor_node_path($_yes__has_steps__ancestor_node_path.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ancestor_node_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_ancestor_node_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_ancestor_variable_path($_ancestor_variable_path: read_api.Cancestor_variable_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_ancestor_variable_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__ancestor_variable_path = $_ancestor_variable_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__ancestor_variable_path = $_ancestor_variable_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_ancestor_variable_path($_yes__has_steps__ancestor_variable_path.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ancestor_variable_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_ancestor_variable_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_command($_command__application: read_api.Ccommand__application) {
	const raw_data: Record<string, any> = {};
	raw_data["expression"] = serialize_command_expression($_command__application.properties.expression);
	{
		let raw_has_next_command: Record<string, any>;
		switch ($_command__application.properties.has_next_command.state.name) {
			case 'no': {
				const $_no__has_next_command = $_command__application.properties.has_next_command.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_next_command = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_next_command = $_command__application.properties.has_next_command.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["command"] = serialize_command($_yes__has_next_command.properties.command);
				raw_has_next_command = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_command__application.properties.has_next_command.state)
		}
		raw_data["has next command"] = [$_command__application.properties.has_next_command.state.name, raw_has_next_command];
	}
	return raw_data;
}
function serialize_command_expression($_command_expression: read_api.Ccommand_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_operation: Record<string, any>;
		switch ($_command_expression.properties.operation.state.name) {
			case 'entry': {
				const $_entry__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_entry__operation__command_expression.properties.type.state.name) {
						case 'create': {
							const $_create__type__entry__operation__command_expression = $_entry__operation__command_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["behaviour"] = serialize_command_object_initialization_behaviour($_create__type__entry__operation__command_expression.properties.behaviour);
							raw_data["expression"] = serialize_command_object_expression($_create__type__entry__operation__command_expression.properties.expression);
							raw_type = raw_data
							break;
						}
						case 'delete': {
							const $_delete__type__entry__operation__command_expression = $_entry__operation__command_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["path"] = serialize_singular_node_path($_delete__type__entry__operation__command_expression.properties.path);
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_entry__operation__command_expression.properties.type.state)
					}
					raw_data["type"] = [$_entry__operation__command_expression.properties.type.state.name, raw_type];
				}
				raw_operation = raw_data
				break;
			}
			case 'execute operation': {
				const $_execute_operation__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["command"] = $_execute_operation__operation__command_expression.properties.command.entry;
				raw_data["expression"] = serialize_command_object_expression($_execute_operation__operation__command_expression.properties.expression);
				raw_data["path"] = serialize_singular_node_path($_execute_operation__operation__command_expression.properties.path);
				raw_operation = raw_data
				break;
			}
			case 'ignore': {
				const $_ignore__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_operation = raw_data
				break;
			}
			case 'node switch': {
				const $_node_switch__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				let raw_cases: Record<string, any>;
				{
					const $_cases__node_switch__operation__command_expression = $_node_switch__operation__command_expression.properties.cases;
					const raw_data: Record<string, any> = {};
					let raw_node_case: Record<string, any>;
					{
						const $_node_case__cases__node_switch__operation__command_expression = $_cases__node_switch__operation__command_expression.properties.node_case;
						const raw_data: Record<string, any> = {};
						raw_data["expression"] = serialize_command_expression($_node_case__cases__node_switch__operation__command_expression.properties.expression);
						raw_data["variable assignment"] = serialize_optional_variable_assignment($_node_case__cases__node_switch__operation__command_expression.properties.variable_assignment);
						raw_node_case = raw_data
					}
					raw_data["node case"] = raw_node_case;
					let raw_none_case: Record<string, any>;
					{
						const $_none_case__cases__node_switch__operation__command_expression = $_cases__node_switch__operation__command_expression.properties.none_case;
						const raw_data: Record<string, any> = {};
						raw_data["expression"] = serialize_command_expression($_none_case__cases__node_switch__operation__command_expression.properties.expression);
						raw_none_case = raw_data
					}
					raw_data["none case"] = raw_none_case;
					raw_cases = raw_data
				}
				raw_data["cases"] = raw_cases;
				raw_data["expression"] = serialize_node_expression($_node_switch__operation__command_expression.properties.expression);
				raw_operation = raw_data
				break;
			}
			case 'produce value': {
				const $_produce_value__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_value: Record<string, any>;
					switch ($_produce_value__operation__command_expression.properties.value.state.name) {
						case 'current value': {
							const $_current_value__value = $_produce_value__operation__command_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_command_expression($_current_value__value.properties.expression);
							raw_value = raw_data
							break;
						}
						case 'empty collection': {
							const $_empty_collection = $_produce_value__operation__command_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_value = raw_data
							break;
						}
						case 'object': {
							const $_object__value__produce_value__operation__command_expression = $_produce_value__operation__command_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_command_object_expression($_object__value__produce_value__operation__command_expression.properties.expression);
							raw_value = raw_data
							break;
						}
						case 'scalar': {
							const $_scalar__value__produce_value__operation__command_expression = $_produce_value__operation__command_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_scalar_expression($_scalar__value__produce_value__operation__command_expression.properties.expression);
							raw_value = raw_data
							break;
						}
						case 'state': {
							const $_state__value__produce_value__operation__command_expression = $_produce_value__operation__command_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["behaviour"] = serialize_command_object_initialization_behaviour($_state__value__produce_value__operation__command_expression.properties.behaviour);
							raw_data["expression"] = serialize_command_object_expression($_state__value__produce_value__operation__command_expression.properties.expression);
							raw_data["state"] = $_state__value__produce_value__operation__command_expression.properties.state.entry;
							raw_value = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_produce_value__operation__command_expression.properties.value.state)
					}
					raw_data["value"] = [$_produce_value__operation__command_expression.properties.value.state.name, raw_value];
				}
				raw_operation = raw_data
				break;
			}
			case 'state switch': {
				const $_state_switch__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				let raw_path: Record<string, any>;
				{
					const $_path__state_switch__operation__command_expression = $_state_switch__operation__command_expression.properties.path;
					const raw_data: Record<string, any> = {};
					raw_data["path"] = serialize_singular_node_path($_path__state_switch__operation__command_expression.properties.path);
					raw_data["stategroup"] = $_path__state_switch__operation__command_expression.properties.stategroup.entry;
					raw_path = raw_data
				}
				raw_data["path"] = raw_path;
				const raw_states: Record<string, any> = {};
				for (let [k,v] of $_state_switch__operation__command_expression.properties.states) {
					const $_states__state_switch__operation__command_expression = v;
					const raw_data: Record<string, any> = {};
					raw_data["expression"] = serialize_command_expression($_states__state_switch__operation__command_expression.properties.expression);
					raw_data["variable assignment"] = serialize_optional_variable_assignment($_states__state_switch__operation__command_expression.properties.variable_assignment);
					raw_states[k] = raw_data
				}
				raw_data["states"] = raw_states;
				raw_operation = raw_data
				break;
			}
			case 'update properties': {
				const $_update_properties__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["path"] = serialize_singular_node_path($_update_properties__operation__command_expression.properties.path);
				{
					let raw_target: Record<string, any>;
					switch ($_update_properties__operation__command_expression.properties.target.state.name) {
						case 'node': {
							const $_node__target__update_properties__operation__command_expression = $_update_properties__operation__command_expression.properties.target.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_command_object_expression($_node__target__update_properties__operation__command_expression.properties.expression);
							raw_target = raw_data
							break;
						}
						case 'property': {
							const $_property__target__update_properties__operation__command_expression = $_update_properties__operation__command_expression.properties.target.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_command_expression($_property__target__update_properties__operation__command_expression.properties.expression);
							raw_data["property"] = $_property__target__update_properties__operation__command_expression.properties.property.entry;
							raw_target = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_update_properties__operation__command_expression.properties.target.state)
					}
					raw_data["target"] = [$_update_properties__operation__command_expression.properties.target.state.name, raw_target];
				}
				raw_operation = raw_data
				break;
			}
			case 'walk': {
				const $_walk__operation__command_expression = $_command_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expression"] = serialize_command_expression($_walk__operation__command_expression.properties.expression);
				raw_data["path"] = serialize_singular_node_path($_walk__operation__command_expression.properties.path);
				raw_data["tail"] = serialize_node_path_tail($_walk__operation__command_expression.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_walk__operation__command_expression.properties.type.state.name) {
						case 'collection': {
							const $_collection__type__walk = $_walk__operation__command_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection"] = $_collection__type__walk.properties.collection.entry;
							raw_type = raw_data
							break;
						}
						case 'reference set': {
							const $_reference_set__type__walk = $_walk__operation__command_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["reference set"] = $_reference_set__type__walk.properties.reference_set.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_walk__operation__command_expression.properties.type.state)
					}
					raw_data["type"] = [$_walk__operation__command_expression.properties.type.state.name, raw_type];
				}
				raw_data["variable assignment"] = serialize_optional_variable_assignment($_walk__operation__command_expression.properties.variable_assignment);
				raw_operation = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_command_expression.properties.operation.state)
		}
		raw_data["operation"] = [$_command_expression.properties.operation.state.name, raw_operation];
	}
	return raw_data;
}
function serialize_command_object_expression($_command_object_expression: read_api.Ccommand_object_expression) {
	const raw_data: Record<string, any> = {};
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_command_object_expression.properties.properties) {
		const $_properties__command_object_expression = v;
		const raw_data: Record<string, any> = {};
		raw_data["expression"] = serialize_command_expression($_properties__command_object_expression.properties.expression);
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_command_object_initialization_behaviour($_command_object_initialization_behaviour: read_api.Ccommand_object_initialization_behaviour) {
	const raw_data: Record<string, any> = {};
	{
		let raw_behaviour: Record<string, any>;
		switch ($_command_object_initialization_behaviour.properties.behaviour.state.name) {
			case 'ensure existence': {
				const $_ensure_existence = $_command_object_initialization_behaviour.properties.behaviour.state.node;
				const raw_data: Record<string, any> = {};
				raw_behaviour = raw_data
				break;
			}
			case 'fail when exists': {
				const $_fail_when_exists = $_command_object_initialization_behaviour.properties.behaviour.state.node;
				const raw_data: Record<string, any> = {};
				raw_behaviour = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_command_object_initialization_behaviour.properties.behaviour.state)
		}
		raw_data["behaviour"] = [$_command_object_initialization_behaviour.properties.behaviour.state.name, raw_behaviour];
	}
	return raw_data;
}
function serialize_command_permission_definition($_command_permission_definition: read_api.Ccommand_permission_definition) {
	const raw_data: Record<string, any> = {};
	{
		let raw_execute_permission: Record<string, any>;
		switch ($_command_permission_definition.properties.execute_permission.state.name) {
			case 'explicit': {
				const $_explicit__execute_permission = $_command_permission_definition.properties.execute_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["requirement"] = serialize_user_requirement($_explicit__execute_permission.properties.requirement);
				raw_execute_permission = raw_data
				break;
			}
			case 'reachable': {
				const $_reachable = $_command_permission_definition.properties.execute_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_execute_permission = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_command_permission_definition.properties.execute_permission.state)
		}
		raw_data["execute permission"] = [$_command_permission_definition.properties.execute_permission.state.name, raw_execute_permission];
	}
	return raw_data;
}
function serialize_conditional_node_path($_conditional_node_path: read_api.Cconditional_node_path) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_node_path($_conditional_node_path.properties.path);
	return raw_data;
}
function serialize_constant_number_value($_constant_number_value: read_api.Cconstant_number_value) {
	const raw_data: Record<string, any> = {};
	raw_data["value"] = $_constant_number_value.properties.value.value;
	return raw_data;
}
function serialize_context_node_path($_context_node_path: read_api.Ccontext_node_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_context: Record<string, any>;
		switch ($_context_node_path.properties.context.state.name) {
			case 'dynamic user': {
				const $_dynamic_user__context__context_node_path = $_context_node_path.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				raw_context = raw_data
				break;
			}
			case 'this': {
				const $_this__context__context_node_path = $_context_node_path.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				raw_context = raw_data
				break;
			}
			case 'variable': {
				const $_variable__context__context_node_path = $_context_node_path.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_name: Record<string, any>;
					switch ($_variable__context__context_node_path.properties.name.state.name) {
						case 'explicit': {
							const $_explicit__name__variable = $_variable__context__context_node_path.properties.name.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["head"] = serialize_ancestor_variable_path($_explicit__name__variable.properties.head);
							raw_data["variable"] = $_explicit__name__variable.properties.variable.entry;
							raw_name = raw_data
							break;
						}
						case 'implicit': {
							const $_implicit__name__variable = $_variable__context__context_node_path.properties.name.state.node;
							const raw_data: Record<string, any> = {};
							raw_name = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_variable__context__context_node_path.properties.name.state)
					}
					raw_data["name"] = [$_variable__context__context_node_path.properties.name.state.name, raw_name];
				}
				raw_context = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_context_node_path.properties.context.state)
		}
		raw_data["context"] = [$_context_node_path.properties.context.state.name, raw_context];
	}
	return raw_data;
}
function serialize_context_object_step($_context_object_step: read_api.Ccontext_object_step) {
	const raw_data: Record<string, any> = {};
	{
		let raw_context: Record<string, any>;
		switch ($_context_object_step.properties.context.state.name) {
			case 'dynamic user': {
				const $_dynamic_user__context__context_object_step = $_context_object_step.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				raw_context = raw_data
				break;
			}
			case 'this': {
				const $_this__context__context_object_step = $_context_object_step.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				raw_context = raw_data
				break;
			}
			case 'variable': {
				const $_variable__context__context_object_step = $_context_object_step.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["step"] = serialize_named_object_step($_variable__context__context_object_step.properties.step);
				raw_context = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_context_object_step.properties.context.state)
		}
		raw_data["context"] = [$_context_object_step.properties.context.state.name, raw_context];
	}
	return raw_data;
}
function serialize_dependency_step($_dependency_step: read_api.Cdependency_step) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_dependency_step.properties.type.state.name) {
			case 'reference': {
				const $_reference__type__dependency_step = $_dependency_step.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["property"] = serialize_property_step($_reference__type__dependency_step.properties.property);
				raw_type = raw_data
				break;
			}
			case 'reference rule': {
				const $_reference_rule = $_dependency_step.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["property"] = serialize_property_step($_reference_rule.properties.property);
				raw_data["rule"] = serialize_where_rule_step($_reference_rule.properties.rule);
				raw_type = raw_data
				break;
			}
			case 'state context rule': {
				const $_state_context_rule__type__dependency_step = $_dependency_step.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["rule"] = serialize_where_rule_step($_state_context_rule__type__dependency_step.properties.rule);
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_dependency_step.properties.type.state)
		}
		raw_data["type"] = [$_dependency_step.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_derivation_expression($_derivation_expression: read_api.Cderivation_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_derivation_expression.properties.type.state.name) {
			case 'node switch': {
				const $_node_switch__type = $_derivation_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				let raw_cases: Record<string, any>;
				{
					const $_cases__node_switch__type = $_node_switch__type.properties.cases;
					const raw_data: Record<string, any> = {};
					let raw_node: Record<string, any>;
					{
						const $_node__cases = $_cases__node_switch__type.properties.node;
						const raw_data: Record<string, any> = {};
						raw_data["expression"] = serialize_derivation_expression($_node__cases.properties.expression);
						raw_data["variable assignment"] = serialize_optional_named_object_assignment($_node__cases.properties.variable_assignment);
						raw_node = raw_data
					}
					raw_data["node"] = raw_node;
					raw_data["none"] = serialize_derivation_expression($_cases__node_switch__type.properties.none);
					raw_cases = raw_data
				}
				raw_data["cases"] = raw_cases;
				raw_data["node path"] = serialize_variablized_object_path($_node_switch__type.properties.node_path);
				{
					let raw_operation: Record<string, any>;
					switch ($_node_switch__type.properties.operation.state.name) {
						case 'equality': {
							const $_equality__operation = $_node_switch__type.properties.operation.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["other node path"] = serialize_singular_variablized_object_path($_equality__operation.properties.other_node_path);
							raw_operation = raw_data
							break;
						}
						case 'existence': {
							const $_existence__operation = $_node_switch__type.properties.operation.state.node;
							const raw_data: Record<string, any> = {};
							raw_operation = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_node_switch__type.properties.operation.state)
					}
					raw_data["operation"] = [$_node_switch__type.properties.operation.state.name, raw_operation];
				}
				raw_type = raw_data
				break;
			}
			case 'number switch': {
				const $_number_switch = $_derivation_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_cases: Record<string, any> = {};
				for (let [k,v] of $_number_switch.properties.cases) {
					const $_cases__number_switch = v;
					const raw_data: Record<string, any> = {};
					raw_data["expression"] = serialize_derivation_expression($_cases__number_switch.properties.expression);
					{
						let raw_has_predecessor: Record<string, any>;
						switch ($_cases__number_switch.properties.has_predecessor.state.name) {
							case 'no': {
								const $_no__has_predecessor__cases = $_cases__number_switch.properties.has_predecessor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_predecessor = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_predecessor__cases = $_cases__number_switch.properties.has_predecessor.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["case"] = $_yes__has_predecessor__cases.properties.case_.entry;
								raw_has_predecessor = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_cases__number_switch.properties.has_predecessor.state)
						}
						raw_data["has predecessor"] = [$_cases__number_switch.properties.has_predecessor.state.name, raw_has_predecessor];
					}
					raw_data["variable assignment"] = serialize_optional_named_object_assignment($_cases__number_switch.properties.variable_assignment);
					raw_cases[k] = raw_data
				}
				raw_data["cases"] = raw_cases;
				{
					let raw_compare_to: Record<string, any>;
					switch ($_number_switch.properties.compare_to.state.name) {
						case 'constant': {
							const $_constant__compare_to = $_number_switch.properties.compare_to.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["value"] = serialize_constant_number_value($_constant__compare_to.properties.value);
							raw_compare_to = raw_data
							break;
						}
						case 'path': {
							const $_path__compare_to = $_number_switch.properties.compare_to.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["right number path"] = serialize_singular_variablized_object_path($_path__compare_to.properties.right_number_path);
							raw_compare_to = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_number_switch.properties.compare_to.state)
					}
					raw_data["compare to"] = [$_number_switch.properties.compare_to.state.name, raw_compare_to];
				}
				raw_data["last case"] = $_number_switch.properties.last_case.entry;
				raw_data["number path"] = serialize_singular_variablized_object_path($_number_switch.properties.number_path);
				raw_type = raw_data
				break;
			}
			case 'produce value': {
				const $_produce_value__type = $_derivation_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expression"] = serialize_derivation_expression_tail($_produce_value__type.properties.expression);
				raw_type = raw_data
				break;
			}
			case 'recurse': {
				const $_recurse = $_derivation_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_step: Record<string, any>;
					switch ($_recurse.properties.step.state.name) {
						case 'repeat': {
							const $_repeat = $_recurse.properties.step.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["recursion start"] = serialize_named_object_step($_repeat.properties.recursion_start);
							raw_data["sibling node path"] = serialize_singular_variablized_object_path($_repeat.properties.sibling_node_path);
							raw_step = raw_data
							break;
						}
						case 'start': {
							const $_start = $_recurse.properties.step.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["binding node path"] = serialize_singular_variablized_object_path($_start.properties.binding_node_path);
							raw_data["expression"] = serialize_derivation_expression($_start.properties.expression);
							raw_data["graph traversal"] = serialize_graph_traversal_definition($_start.properties.graph_traversal);
							raw_data["recursion start assignment"] = serialize_named_object_assignment($_start.properties.recursion_start_assignment);
							raw_step = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_recurse.properties.step.state)
					}
					raw_data["step"] = [$_recurse.properties.step.state.name, raw_step];
				}
				raw_type = raw_data
				break;
			}
			case 'set switch': {
				const $_set_switch = $_derivation_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				let raw_cases: Record<string, any>;
				{
					const $_cases__set_switch = $_set_switch.properties.cases;
					const raw_data: Record<string, any> = {};
					{
						let raw_match_node: Record<string, any>;
						switch ($_cases__set_switch.properties.match_node.state.name) {
							case 'no': {
								const $_no__match_node = $_cases__set_switch.properties.match_node.state.node;
								const raw_data: Record<string, any> = {};
								raw_match_node = raw_data
								break;
							}
							case 'yes': {
								const $_yes__match_node = $_cases__set_switch.properties.match_node.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["expression"] = serialize_derivation_expression($_yes__match_node.properties.expression);
								raw_data["variable assignment"] = serialize_optional_named_object_assignment($_yes__match_node.properties.variable_assignment);
								raw_match_node = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_cases__set_switch.properties.match_node.state)
						}
						raw_data["match node"] = [$_cases__set_switch.properties.match_node.state.name, raw_match_node];
					}
					{
						let raw_match_nodes: Record<string, any>;
						switch ($_cases__set_switch.properties.match_nodes.state.name) {
							case 'no': {
								const $_no__match_nodes = $_cases__set_switch.properties.match_nodes.state.node;
								const raw_data: Record<string, any> = {};
								raw_match_nodes = raw_data
								break;
							}
							case 'yes': {
								const $_yes__match_nodes = $_cases__set_switch.properties.match_nodes.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["expression"] = serialize_derivation_expression($_yes__match_nodes.properties.expression);
								raw_data["variable assignment"] = serialize_optional_named_object_assignment($_yes__match_nodes.properties.variable_assignment);
								raw_match_nodes = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_cases__set_switch.properties.match_nodes.state)
						}
						raw_data["match nodes"] = [$_cases__set_switch.properties.match_nodes.state.name, raw_match_nodes];
					}
					{
						let raw_match_none: Record<string, any>;
						switch ($_cases__set_switch.properties.match_none.state.name) {
							case 'no': {
								const $_no__match_none = $_cases__set_switch.properties.match_none.state.node;
								const raw_data: Record<string, any> = {};
								raw_match_none = raw_data
								break;
							}
							case 'yes': {
								const $_yes__match_none = $_cases__set_switch.properties.match_none.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["expression"] = serialize_derivation_expression($_yes__match_none.properties.expression);
								raw_match_none = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_cases__set_switch.properties.match_none.state)
						}
						raw_data["match none"] = [$_cases__set_switch.properties.match_none.state.name, raw_match_none];
					}
					raw_cases = raw_data
				}
				raw_data["cases"] = raw_cases;
				raw_data["nodes path"] = serialize_object_set_path($_set_switch.properties.nodes_path);
				raw_type = raw_data
				break;
			}
			case 'state switch': {
				const $_state_switch__type = $_derivation_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["state group path"] = serialize_singular_variablized_object_path($_state_switch__type.properties.state_group_path);
				const raw_states: Record<string, any> = {};
				for (let [k,v] of $_state_switch__type.properties.states) {
					const $_states__state_switch__type = v;
					const raw_data: Record<string, any> = {};
					raw_data["expression"] = serialize_derivation_expression($_states__state_switch__type.properties.expression);
					raw_data["variable assignment"] = serialize_optional_named_object_assignment($_states__state_switch__type.properties.variable_assignment);
					raw_states[k] = raw_data
				}
				raw_data["states"] = raw_states;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_derivation_expression.properties.type.state)
		}
		raw_data["type"] = [$_derivation_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_derivation_expression_list($_derivation_expression_list: read_api.Cderivation_expression_list) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_tail: Record<string, any>;
		switch ($_derivation_expression_list.properties.has_tail.state.name) {
			case 'no': {
				const $_no__has_tail__derivation_expression_list = $_derivation_expression_list.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_tail = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_tail__derivation_expression_list = $_derivation_expression_list.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_derivation_expression_list($_yes__has_tail__derivation_expression_list.properties.tail);
				raw_has_tail = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_derivation_expression_list.properties.has_tail.state)
		}
		raw_data["has tail"] = [$_derivation_expression_list.properties.has_tail.state.name, raw_has_tail];
	}
	raw_data["head"] = serialize_derivation_expression_tail($_derivation_expression_list.properties.head);
	return raw_data;
}
function serialize_derivation_expression_tail($_derivation_expression_tail: read_api.Cderivation_expression_tail) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_derivation_expression_tail.properties.type.state.name) {
			case 'dynamic': {
				const $_dynamic__type__derivation_expression_tail = $_derivation_expression_tail.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["path"] = serialize_singular_variablized_object_path($_dynamic__type__derivation_expression_tail.properties.path);
				raw_type = raw_data
				break;
			}
			case 'number': {
				const $_number__type__derivation_expression_tail = $_derivation_expression_tail.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expression"] = serialize_number_expression($_number__type__derivation_expression_tail.properties.expression);
				raw_type = raw_data
				break;
			}
			case 'reference': {
				const $_reference__type__derivation_expression_tail = $_derivation_expression_tail.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_reference__type__derivation_expression_tail.properties.type.state.name) {
						case 'branch': {
							const $_branch = $_reference__type__derivation_expression_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["branch"] = $_branch.properties.branch.entry;
							raw_data["expression"] = serialize_singular_variablized_object_path($_branch.properties.expression);
							raw_type = raw_data
							break;
						}
						case 'ordered graph node': {
							const $_ordered_graph_node = $_reference__type__derivation_expression_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection path"] = serialize_singular_variablized_object_path($_ordered_graph_node.properties.collection_path);
							raw_data["ordered graph"] = $_ordered_graph_node.properties.ordered_graph.entry;
							{
								let raw_type: Record<string, any>;
								switch ($_ordered_graph_node.properties.type.state.name) {
									case 'sink': {
										const $_sink = $_ordered_graph_node.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_type = raw_data
										break;
									}
									case 'source': {
										const $_source = $_ordered_graph_node.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_type = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_ordered_graph_node.properties.type.state)
								}
								raw_data["type"] = [$_ordered_graph_node.properties.type.state.name, raw_type];
							}
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_reference__type__derivation_expression_tail.properties.type.state)
					}
					raw_data["type"] = [$_reference__type__derivation_expression_tail.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			case 'state': {
				const $_state__type__derivation_expression_tail = $_derivation_expression_tail.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["initializer"] = serialize_state_initializer($_state__type__derivation_expression_tail.properties.initializer);
				raw_type = raw_data
				break;
			}
			case 'text': {
				const $_text__type__derivation_expression_tail = $_derivation_expression_tail.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_text__type__derivation_expression_tail.properties.type.state.name) {
						case 'concatenation': {
							const $_concatenation__type__text__type__derivation_expression_tail = $_text__type__derivation_expression_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_derivation_expression_list($_concatenation__type__text__type__derivation_expression_tail.properties.expression);
							raw_type = raw_data
							break;
						}
						case 'static': {
							const $_static__type__text__type__derivation_expression_tail = $_text__type__derivation_expression_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["value"] = $_static__type__text__type__derivation_expression_tail.properties.value;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_text__type__derivation_expression_tail.properties.type.state)
					}
					raw_data["type"] = [$_text__type__derivation_expression_tail.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_derivation_expression_tail.properties.type.state)
		}
		raw_data["type"] = [$_derivation_expression_tail.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_descendant_base_property_path($_descendant_base_property_path: read_api.Cdescendant_base_property_path) {
	const raw_data: Record<string, any> = {};
	raw_data["head"] = serialize_object_path_tail($_descendant_base_property_path.properties.head);
	raw_data["property"] = $_descendant_base_property_path.properties.property.entry;
	return raw_data;
}
function serialize_descendant_object_path($_descendant_object_path: read_api.Cdescendant_object_path) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_object_path_tail($_descendant_object_path.properties.path);
	return raw_data;
}
function serialize_direction_annotation($_direction_annotation: read_api.Cdirection_annotation) {
	const raw_data: Record<string, any> = {};
	{
		let raw_direction: Record<string, any>;
		switch ($_direction_annotation.properties.direction.state.name) {
			case 'downstream': {
				const $_downstream__direction__direction_annotation = $_direction_annotation.properties.direction.state.node;
				const raw_data: Record<string, any> = {};
				raw_direction = raw_data
				break;
			}
			case 'upstream': {
				const $_upstream__direction__direction_annotation = $_direction_annotation.properties.direction.state.node;
				const raw_data: Record<string, any> = {};
				raw_direction = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_direction_annotation.properties.direction.state)
		}
		raw_data["direction"] = [$_direction_annotation.properties.direction.state.name, raw_direction];
	}
	return raw_data;
}
function serialize_entry_reference_definition($_entry_reference_definition: read_api.Centry_reference_definition) {
	const raw_data: Record<string, any> = {};
	raw_data["collection path"] = serialize_variablized_object_path($_entry_reference_definition.properties.collection_path);
	raw_data["tail"] = serialize_descendant_object_path($_entry_reference_definition.properties.tail);
	{
		let raw_type: Record<string, any>;
		switch ($_entry_reference_definition.properties.type.state.name) {
			case 'sibling': {
				const $_sibling__type__entry_reference_definition = $_entry_reference_definition.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["definition"] = serialize_sibling_reference_definition($_sibling__type__entry_reference_definition.properties.definition);
				raw_type = raw_data
				break;
			}
			case 'simple': {
				const $_simple__type__entry_reference_definition = $_entry_reference_definition.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_entry_reference_definition.properties.type.state)
		}
		raw_data["type"] = [$_entry_reference_definition.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_entry_reference_selector($_entry_reference_selector: read_api.Centry_reference_selector) {
	const raw_data: Record<string, any> = {};
	{
		let raw_definer: Record<string, any>;
		switch ($_entry_reference_selector.properties.definer.state.name) {
			case 'property': {
				const $_property__definer = $_entry_reference_selector.properties.definer.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["property"] = $_property__definer.properties.property.entry;
				raw_definer = raw_data
				break;
			}
			case 'rule': {
				const $_rule = $_entry_reference_selector.properties.definer.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["property"] = $_rule.properties.property.entry;
				raw_data["rule"] = $_rule.properties.rule.entry;
				raw_definer = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_entry_reference_selector.properties.definer.state)
		}
		raw_data["definer"] = [$_entry_reference_selector.properties.definer.state.name, raw_definer];
	}
	return raw_data;
}
function serialize_flatten_expression($_flatten_expression: read_api.Cflatten_expression) {
	const raw_data: Record<string, any> = {};
	raw_data["head"] = serialize_group_ancestor_node_path($_flatten_expression.properties.head);
	raw_data["path"] = serialize_plural_descendant_node_path($_flatten_expression.properties.path);
	return raw_data;
}
function serialize_graph_constraints_definition($_graph_constraints_definition: read_api.Cgraph_constraints_definition) {
	const raw_data: Record<string, any> = {};
	const raw_graphs: Record<string, any> = {};
	for (let [k,v] of $_graph_constraints_definition.properties.graphs) {
		const $_graphs = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_graphs.properties.type.state.name) {
				case 'acyclic': {
					const $_acyclic = $_graphs.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				case 'ordered': {
					const $_ordered = $_graphs.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					let raw_ordering_property_path: Record<string, any>;
					{
						const $_ordering_property_path = $_ordered.properties.ordering_property_path;
						const raw_data: Record<string, any> = {};
						raw_data["ordering state group path"] = serialize_descendant_base_property_path($_ordering_property_path.properties.ordering_state_group_path);
						let raw_ordering_states: Record<string, any>;
						{
							const $_ordering_states = $_ordering_property_path.properties.ordering_states;
							const raw_data: Record<string, any> = {};
							raw_data["edge reference"] = $_ordering_states.properties.edge_reference.entry;
							raw_data["edge state"] = $_ordering_states.properties.edge_state.entry;
							raw_data["sink state"] = $_ordering_states.properties.sink_state.entry;
							raw_ordering_states = raw_data
						}
						raw_data["ordering states"] = raw_ordering_states;
						raw_ordering_property_path = raw_data
					}
					raw_data["ordering property path"] = raw_ordering_property_path;
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_graphs.properties.type.state)
			}
			raw_data["type"] = [$_graphs.properties.type.state.name, raw_type];
		}
		{
			let raw_value_type: Record<string, any>;
			switch ($_graphs.properties.value_type.state.name) {
				case 'base': {
					const $_base__value_type = $_graphs.properties.value_type.state.node;
					const raw_data: Record<string, any> = {};
					raw_value_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_graphs.properties.value_type.state)
			}
			raw_data["value type"] = [$_graphs.properties.value_type.state.name, raw_value_type];
		}
		raw_graphs[k] = raw_data
	}
	raw_data["graphs"] = raw_graphs;
	return raw_data;
}
function serialize_graph_traversal_definition($_graph_traversal_definition: read_api.Cgraph_traversal_definition) {
	const raw_data: Record<string, any> = {};
	raw_data["graph"] = $_graph_traversal_definition.properties.graph.entry;
	{
		let raw_traversal_type: Record<string, any>;
		switch ($_graph_traversal_definition.properties.traversal_type.state.name) {
			case 'base order': {
				const $_base_order = $_graph_traversal_definition.properties.traversal_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_traversal_type = raw_data
				break;
			}
			case 'inverse order': {
				const $_inverse_order = $_graph_traversal_definition.properties.traversal_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_traversal_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_graph_traversal_definition.properties.traversal_type.state)
		}
		raw_data["traversal type"] = [$_graph_traversal_definition.properties.traversal_type.state.name, raw_traversal_type];
	}
	return raw_data;
}
function serialize_graph_traversal_selector($_graph_traversal_selector: read_api.Cgraph_traversal_selector) {
	const raw_data: Record<string, any> = {};
	raw_data["ancestor path"] = serialize_ancestor_node_path($_graph_traversal_selector.properties.ancestor_path);
	raw_data["graph traversal"] = serialize_graph_traversal_definition($_graph_traversal_selector.properties.graph_traversal);
	{
		let raw_has_tail: Record<string, any>;
		switch ($_graph_traversal_selector.properties.has_tail.state.name) {
			case 'no': {
				const $_no__has_tail__graph_traversal_selector = $_graph_traversal_selector.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_tail = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_tail__graph_traversal_selector = $_graph_traversal_selector.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_graph_traversal_selector($_yes__has_tail__graph_traversal_selector.properties.tail);
				raw_has_tail = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_graph_traversal_selector.properties.has_tail.state)
		}
		raw_data["has tail"] = [$_graph_traversal_selector.properties.has_tail.state.name, raw_has_tail];
	}
	return raw_data;
}
function serialize_group_ancestor_node_path($_group_ancestor_node_path: read_api.Cgroup_ancestor_node_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_group_ancestor_node_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__group_ancestor_node_path = $_group_ancestor_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__group_ancestor_node_path = $_group_ancestor_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_group_ancestor_node_path($_yes__has_steps__group_ancestor_node_path.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_group_ancestor_node_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_group_ancestor_node_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_identity_initializer($_identity_initializer: read_api.Cidentity_initializer) {
	const raw_data: Record<string, any> = {};
	raw_data["initializer"] = serialize_command_object_expression($_identity_initializer.properties.initializer);
	return raw_data;
}
function serialize_interface_instance_initializer($_interface_instance_initializer: read_api.Cinterface_instance_initializer) {
	const raw_data: Record<string, any> = {};
	raw_data["initializer"] = serialize_command_object_expression($_interface_instance_initializer.properties.initializer);
	return raw_data;
}
function serialize_item_permissions_definition($_item_permissions_definition: read_api.Citem_permissions_definition) {
	const raw_data: Record<string, any> = {};
	{
		let raw_create_permission: Record<string, any>;
		switch ($_item_permissions_definition.properties.create_permission.state.name) {
			case 'explicit': {
				const $_explicit__create_permission = $_item_permissions_definition.properties.create_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["permission"] = serialize_permission($_explicit__create_permission.properties.permission);
				raw_create_permission = raw_data
				break;
			}
			case 'inherited': {
				const $_inherited__create_permission = $_item_permissions_definition.properties.create_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_create_permission = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_item_permissions_definition.properties.create_permission.state)
		}
		raw_data["create permission"] = [$_item_permissions_definition.properties.create_permission.state.name, raw_create_permission];
	}
	{
		let raw_delete_permission: Record<string, any>;
		switch ($_item_permissions_definition.properties.delete_permission.state.name) {
			case 'explicit': {
				const $_explicit__delete_permission = $_item_permissions_definition.properties.delete_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["permission"] = serialize_permission($_explicit__delete_permission.properties.permission);
				raw_delete_permission = raw_data
				break;
			}
			case 'inherited': {
				const $_inherited__delete_permission = $_item_permissions_definition.properties.delete_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_delete_permission = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_item_permissions_definition.properties.delete_permission.state)
		}
		raw_data["delete permission"] = [$_item_permissions_definition.properties.delete_permission.state.name, raw_delete_permission];
	}
	return raw_data;
}
function serialize_lower_bound_cardinality_constraint($_lower_bound_cardinality_constraint: read_api.Clower_bound_cardinality_constraint) {
	const raw_data: Record<string, any> = {};
	{
		let raw_constraint: Record<string, any>;
		switch ($_lower_bound_cardinality_constraint.properties.constraint.state.name) {
			case 'non empty': {
				const $_non_empty = $_lower_bound_cardinality_constraint.properties.constraint.state.node;
				const raw_data: Record<string, any> = {};
				raw_constraint = raw_data
				break;
			}
			case 'none': {
				const $_none__constraint = $_lower_bound_cardinality_constraint.properties.constraint.state.node;
				const raw_data: Record<string, any> = {};
				raw_constraint = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_lower_bound_cardinality_constraint.properties.constraint.state)
		}
		raw_data["constraint"] = [$_lower_bound_cardinality_constraint.properties.constraint.state.name, raw_constraint];
	}
	return raw_data;
}
function serialize_named_object_assignment($_named_object_assignment: read_api.Cnamed_object_assignment) {
	const raw_data: Record<string, any> = {};
	{
		let raw_name: Record<string, any>;
		switch ($_named_object_assignment.properties.name.state.name) {
			case 'explicit': {
				const $_explicit__name__named_object_assignment = $_named_object_assignment.properties.name.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_explicit__name__named_object_assignment.properties.name.entry;
				const raw_named_objects: Record<string, any> = {};
				for (let [k,v] of $_explicit__name__named_object_assignment.properties.named_objects) {
					const $_named_objects__explicit__name__named_object_assignment = v;
					const raw_data: Record<string, any> = {};
					{
						let raw_has_successor: Record<string, any>;
						switch ($_named_objects__explicit__name__named_object_assignment.properties.has_successor.state.name) {
							case 'no': {
								const $_no__has_successor__named_objects__explicit__name__named_object_assignment = $_named_objects__explicit__name__named_object_assignment.properties.has_successor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_successor = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_successor__named_objects__explicit__name__named_object_assignment = $_named_objects__explicit__name__named_object_assignment.properties.has_successor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_successor = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_named_objects__explicit__name__named_object_assignment.properties.has_successor.state)
						}
						raw_data["has successor"] = [$_named_objects__explicit__name__named_object_assignment.properties.has_successor.state.name, raw_has_successor];
					}
					raw_named_objects[k] = raw_data
				}
				raw_data["named objects"] = raw_named_objects;
				raw_name = raw_data
				break;
			}
			case 'implicit': {
				const $_implicit__name__named_object_assignment = $_named_object_assignment.properties.name.state.node;
				const raw_data: Record<string, any> = {};
				raw_name = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_named_object_assignment.properties.name.state)
		}
		raw_data["name"] = [$_named_object_assignment.properties.name.state.name, raw_name];
	}
	return raw_data;
}
function serialize_named_object_step($_named_object_step: read_api.Cnamed_object_step) {
	const raw_data: Record<string, any> = {};
	{
		let raw_name: Record<string, any>;
		switch ($_named_object_step.properties.name.state.name) {
			case 'explicit': {
				const $_explicit__name__named_object_step = $_named_object_step.properties.name.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["head"] = serialize_ancestor_named_object_path($_explicit__name__named_object_step.properties.head);
				raw_data["named object"] = $_explicit__name__named_object_step.properties.named_object.entry;
				raw_name = raw_data
				break;
			}
			case 'implicit': {
				const $_implicit__name__named_object_step = $_named_object_step.properties.name.state.node;
				const raw_data: Record<string, any> = {};
				raw_name = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_named_object_step.properties.name.state)
		}
		raw_data["name"] = [$_named_object_step.properties.name.state.name, raw_name];
	}
	return raw_data;
}
function serialize_node($_node__application: read_api.Cnode__application) {
	const raw_data: Record<string, any> = {};
	const raw_attributes: Record<string, any> = {};
	for (let [k,v] of $_node__application.properties.attributes) {
		const $_attributes = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_has_predecessor: Record<string, any>;
			switch ($_attributes.properties.has_predecessor.state.name) {
				case 'no': {
					const $_no__has_predecessor__attributes = $_attributes.properties.has_predecessor.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_predecessor = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_predecessor__attributes = $_attributes.properties.has_predecessor.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["attribute"] = $_yes__has_predecessor__attributes.properties.attribute.entry;
					raw_has_predecessor = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_attributes.properties.has_predecessor.state)
			}
			raw_data["has predecessor"] = [$_attributes.properties.has_predecessor.state.name, raw_has_predecessor];
		}
		{
			let raw_has_successor: Record<string, any>;
			switch ($_attributes.properties.has_successor.state.name) {
				case 'no': {
					const $_no__has_successor__attributes = $_attributes.properties.has_successor.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_successor = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_successor__attributes = $_attributes.properties.has_successor.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["attribute"] = $_yes__has_successor__attributes.properties.attribute.entry;
					raw_has_successor = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_attributes.properties.has_successor.state)
			}
			raw_data["has successor"] = [$_attributes.properties.has_successor.state.name, raw_has_successor];
		}
		{
			let raw_type: Record<string, any>;
			switch ($_attributes.properties.type.state.name) {
				case 'action': {
					const $_action = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["action"] = serialize_ui_action($_action.properties.action);
					raw_data["parameters"] = serialize_node($_action.properties.parameters);
					raw_data["ui"] = serialize_ui_action_attribute($_action.properties.ui);
					raw_data["variable assignment"] = serialize_optional_variable_assignment($_action.properties.variable_assignment);
					raw_type = raw_data
					break;
				}
				case 'command': {
					const $_command__type = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_implementation: Record<string, any>;
						switch ($_command__type.properties.implementation.state.name) {
							case 'external': {
								const $_external = $_command__type.properties.implementation.state.node;
								const raw_data: Record<string, any> = {};
								raw_implementation = raw_data
								break;
							}
							case 'internal': {
								const $_internal__implementation = $_command__type.properties.implementation.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["implementation"] = serialize_command($_internal__implementation.properties.implementation);
								raw_data["variable assignment"] = serialize_optional_variable_assignment($_internal__implementation.properties.variable_assignment);
								raw_implementation = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_command__type.properties.implementation.state)
						}
						raw_data["implementation"] = [$_command__type.properties.implementation.state.name, raw_implementation];
					}
					raw_data["parameters"] = serialize_node($_command__type.properties.parameters);
					raw_data["permission definition"] = serialize_command_permission_definition($_command__type.properties.permission_definition);
					{
						let raw_type: Record<string, any>;
						switch ($_command__type.properties.type.state.name) {
							case 'component': {
								const $_component = $_command__type.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_type = raw_data
								break;
							}
							case 'global': {
								const $_global = $_command__type.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["ui"] = serialize_ui_command_attribute($_global.properties.ui);
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_command__type.properties.type.state)
						}
						raw_data["type"] = [$_command__type.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				case 'property': {
					const $_property__type__attributes = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_type: Record<string, any>;
						switch ($_property__type__attributes.properties.type.state.name) {
							case 'collection': {
								const $_collection__type__property = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["cardinality constraint"] = serialize_lower_bound_cardinality_constraint($_collection__type__property.properties.cardinality_constraint);
								raw_data["graph constraints"] = serialize_graph_constraints_definition($_collection__type__property.properties.graph_constraints);
								raw_data["key property"] = $_collection__type__property.properties.key_property.entry;
								raw_data["node"] = serialize_node($_collection__type__property.properties.node);
								raw_data["permissions"] = serialize_item_permissions_definition($_collection__type__property.properties.permissions);
								{
									let raw_type: Record<string, any>;
									switch ($_collection__type__property.properties.type.state.name) {
										case 'base': {
											const $_base__type__collection = $_collection__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_type = raw_data
											break;
										}
										case 'derived': {
											const $_derived__type__collection = $_collection__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_key_constraint: Record<string, any>;
												switch ($_derived__type__collection.properties.key_constraint.state.name) {
													case 'no': {
														const $_no__key_constraint = $_derived__type__collection.properties.key_constraint.state.node;
														const raw_data: Record<string, any> = {};
														const raw_branches: Record<string, any> = {};
														for (let [k,v] of $_no__key_constraint.properties.branches) {
															const $_branches__no = v;
															const raw_data: Record<string, any> = {};
															raw_data["expression"] = serialize_flatten_expression($_branches__no.properties.expression);
															raw_data["node initializer"] = serialize_node_initializer($_branches__no.properties.node_initializer);
															raw_data["variable assignment"] = serialize_optional_named_object_assignment($_branches__no.properties.variable_assignment);
															raw_branches[k] = raw_data
														}
														raw_data["branches"] = raw_branches;
														{
															let raw_separator: Record<string, any>;
															switch ($_no__key_constraint.properties.separator.state.name) {
																case 'colon': {
																	const $_colon = $_no__key_constraint.properties.separator.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_separator = raw_data
																	break;
																}
																case 'dash': {
																	const $_dash = $_no__key_constraint.properties.separator.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_separator = raw_data
																	break;
																}
																case 'dot': {
																	const $_dot = $_no__key_constraint.properties.separator.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_separator = raw_data
																	break;
																}
																case 'greater than': {
																	const $_greater_than = $_no__key_constraint.properties.separator.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_separator = raw_data
																	break;
																}
																case 'space': {
																	const $_space = $_no__key_constraint.properties.separator.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_separator = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_no__key_constraint.properties.separator.state)
															}
															raw_data["separator"] = [$_no__key_constraint.properties.separator.state.name, raw_separator];
														}
														raw_key_constraint = raw_data
														break;
													}
													case 'yes': {
														const $_yes__key_constraint = $_derived__type__collection.properties.key_constraint.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["expression"] = serialize_plural_reference_expression($_yes__key_constraint.properties.expression);
														raw_key_constraint = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_derived__type__collection.properties.key_constraint.state)
												}
												raw_data["key constraint"] = [$_derived__type__collection.properties.key_constraint.state.name, raw_key_constraint];
											}
											raw_data["recursion"] = serialize_recursion_annotation($_derived__type__collection.properties.recursion);
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection__type__property.properties.type.state)
									}
									raw_data["type"] = [$_collection__type__property.properties.type.state.name, raw_type];
								}
								raw_data["ui"] = serialize_ui_collection_property($_collection__type__property.properties.ui);
								raw_type = raw_data
								break;
							}
							case 'file': {
								const $_file = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_type: Record<string, any>;
									switch ($_file.properties.type.state.name) {
										case 'base': {
											const $_base__type__file = $_file.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_type = raw_data
											break;
										}
										case 'derived': {
											const $_derived__type__file = $_file.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_value_source: Record<string, any>;
												switch ($_derived__type__file.properties.value_source.state.name) {
													case 'expression': {
														const $_expression__value_source__derived__type__file = $_derived__type__file.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["expression"] = serialize_derivation_expression($_expression__value_source__derived__type__file.properties.expression);
														raw_data["recursion"] = serialize_recursion_annotation($_expression__value_source__derived__type__file.properties.recursion);
														raw_value_source = raw_data
														break;
													}
													case 'parameter': {
														const $_parameter__value_source__derived__type__file = $_derived__type__file.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_value_source = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_derived__type__file.properties.value_source.state)
												}
												raw_data["value source"] = [$_derived__type__file.properties.value_source.state.name, raw_value_source];
											}
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_file.properties.type.state)
									}
									raw_data["type"] = [$_file.properties.type.state.name, raw_type];
								}
								raw_data["ui"] = serialize_ui_file_property($_file.properties.ui);
								raw_type = raw_data
								break;
							}
							case 'group': {
								const $_group__type__property = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["node"] = serialize_node($_group__type__property.properties.node);
								{
									let raw_type: Record<string, any>;
									switch ($_group__type__property.properties.type.state.name) {
										case 'base': {
											const $_base__type__group = $_group__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_type = raw_data
											break;
										}
										case 'derived': {
											const $_derived__type__group = $_group__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_group__type__property.properties.type.state)
									}
									raw_data["type"] = [$_group__type__property.properties.type.state.name, raw_type];
								}
								raw_data["ui"] = serialize_ui_group_property($_group__type__property.properties.ui);
								raw_type = raw_data
								break;
							}
							case 'number': {
								const $_number__type__property = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_behaviour: Record<string, any>;
									switch ($_number__type__property.properties.behaviour.state.name) {
										case 'none': {
											const $_none__behaviour = $_number__type__property.properties.behaviour.state.node;
											const raw_data: Record<string, any> = {};
											raw_behaviour = raw_data
											break;
										}
										case 'timer': {
											const $_timer = $_number__type__property.properties.behaviour.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["implementation"] = serialize_command($_timer.properties.implementation);
											raw_behaviour = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.behaviour.state)
									}
									raw_data["behaviour"] = [$_number__type__property.properties.behaviour.state.name, raw_behaviour];
								}
								raw_data["numerical type"] = $_number__type__property.properties.numerical_type.entry;
								{
									let raw_set_type: Record<string, any>;
									switch ($_number__type__property.properties.set_type.state.name) {
										case 'integer': {
											const $_integer__set_type = $_number__type__property.properties.set_type.state.node;
											const raw_data: Record<string, any> = {};
											raw_set_type = raw_data
											break;
										}
										case 'positive': {
											const $_positive__set_type = $_number__type__property.properties.set_type.state.node;
											const raw_data: Record<string, any> = {};
											raw_set_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.set_type.state)
									}
									raw_data["set type"] = [$_number__type__property.properties.set_type.state.name, raw_set_type];
								}
								{
									let raw_type: Record<string, any>;
									switch ($_number__type__property.properties.type.state.name) {
										case 'base': {
											const $_base__type__number = $_number__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_type: Record<string, any>;
												switch ($_base__type__number.properties.type.state.name) {
													case 'causal': {
														const $_causal = $_base__type__number.properties.type.state.node;
														const raw_data: Record<string, any> = {};
														{
															let raw_type: Record<string, any>;
															switch ($_causal.properties.type.state.name) {
																case 'creation': {
																	const $_creation = $_causal.properties.type.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_type = raw_data
																	break;
																}
																case 'destruction': {
																	const $_destruction = $_causal.properties.type.state.node;
																	const raw_data: Record<string, any> = {};
																	{
																		let raw_destruction_operation: Record<string, any>;
																		switch ($_destruction.properties.destruction_operation.state.name) {
																			case 'add lifetime': {
																				const $_add_lifetime = $_destruction.properties.destruction_operation.state.node;
																				const raw_data: Record<string, any> = {};
																				raw_destruction_operation = raw_data
																				break;
																			}
																			case 'set to lifetime': {
																				const $_set_to_lifetime = $_destruction.properties.destruction_operation.state.node;
																				const raw_data: Record<string, any> = {};
																				raw_destruction_operation = raw_data
																				break;
																			}
																			case 'subtract lifetime': {
																				const $_subtract_lifetime = $_destruction.properties.destruction_operation.state.node;
																				const raw_data: Record<string, any> = {};
																				raw_destruction_operation = raw_data
																				break;
																			}
																			default:
																				throw new Error("unexpected state: " + $_destruction.properties.destruction_operation.state)
																		}
																		raw_data["destruction operation"] = [$_destruction.properties.destruction_operation.state.name, raw_destruction_operation];
																	}
																	raw_data["watched state"] = $_destruction.properties.watched_state.entry;
																	raw_data["watched stategroup"] = $_destruction.properties.watched_stategroup.entry;
																	raw_type = raw_data
																	break;
																}
																case 'mutation': {
																	const $_mutation = $_causal.properties.type.state.node;
																	const raw_data: Record<string, any> = {};
																	raw_data["watched property"] = $_mutation.properties.watched_property.entry;
																	raw_type = raw_data
																	break;
																}
																default:
																	throw new Error("unexpected state: " + $_causal.properties.type.state)
															}
															raw_data["type"] = [$_causal.properties.type.state.name, raw_type];
														}
														raw_type = raw_data
														break;
													}
													case 'simple': {
														const $_simple__type__base = $_base__type__number.properties.type.state.node;
														const raw_data: Record<string, any> = {};
														raw_type = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_base__type__number.properties.type.state)
												}
												raw_data["type"] = [$_base__type__number.properties.type.state.name, raw_type];
											}
											raw_type = raw_data
											break;
										}
										case 'derived': {
											const $_derived__type__number = $_number__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_value_source: Record<string, any>;
												switch ($_derived__type__number.properties.value_source.state.name) {
													case 'expression': {
														const $_expression__value_source__derived__type__number = $_derived__type__number.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["expression"] = serialize_derivation_expression($_expression__value_source__derived__type__number.properties.expression);
														raw_data["recursion"] = serialize_recursion_annotation($_expression__value_source__derived__type__number.properties.recursion);
														raw_value_source = raw_data
														break;
													}
													case 'parameter': {
														const $_parameter__value_source__derived__type__number = $_derived__type__number.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_value_source = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_derived__type__number.properties.value_source.state)
												}
												raw_data["value source"] = [$_derived__type__number.properties.value_source.state.name, raw_value_source];
											}
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_number__type__property.properties.type.state)
									}
									raw_data["type"] = [$_number__type__property.properties.type.state.name, raw_type];
								}
								raw_data["ui"] = serialize_ui_number_property($_number__type__property.properties.ui);
								raw_type = raw_data
								break;
							}
							case 'state group': {
								const $_state_group = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["first state"] = $_state_group.properties.first_state.entry;
								const raw_states: Record<string, any> = {};
								for (let [k,v] of $_state_group.properties.states) {
									const $_states__state_group = v;
									const raw_data: Record<string, any> = {};
									{
										let raw_has_successor: Record<string, any>;
										switch ($_states__state_group.properties.has_successor.state.name) {
											case 'no': {
												const $_no__has_successor__states__state_group = $_states__state_group.properties.has_successor.state.node;
												const raw_data: Record<string, any> = {};
												raw_has_successor = raw_data
												break;
											}
											case 'yes': {
												const $_yes__has_successor__states__state_group = $_states__state_group.properties.has_successor.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["successor"] = $_yes__has_successor__states__state_group.properties.successor.entry;
												raw_has_successor = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_states__state_group.properties.has_successor.state)
										}
										raw_data["has successor"] = [$_states__state_group.properties.has_successor.state.name, raw_has_successor];
									}
									raw_data["node"] = serialize_node($_states__state_group.properties.node);
									raw_data["permissions"] = serialize_item_permissions_definition($_states__state_group.properties.permissions);
									{
										let raw_record_lifetime: Record<string, any>;
										switch ($_states__state_group.properties.record_lifetime.state.name) {
											case 'no': {
												const $_no__record_lifetime = $_states__state_group.properties.record_lifetime.state.node;
												const raw_data: Record<string, any> = {};
												raw_record_lifetime = raw_data
												break;
											}
											case 'yes': {
												const $_yes__record_lifetime = $_states__state_group.properties.record_lifetime.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["creation timestamp"] = $_yes__record_lifetime.properties.creation_timestamp.entry;
												raw_data["meta property"] = $_yes__record_lifetime.properties.meta_property.entry;
												raw_record_lifetime = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_states__state_group.properties.record_lifetime.state)
										}
										raw_data["record lifetime"] = [$_states__state_group.properties.record_lifetime.state.name, raw_record_lifetime];
									}
									raw_data["rules"] = serialize_where_rules_definition($_states__state_group.properties.rules);
									raw_data["ui"] = serialize_ui_state($_states__state_group.properties.ui);
									raw_states[k] = raw_data
								}
								raw_data["states"] = raw_states;
								{
									let raw_type: Record<string, any>;
									switch ($_state_group.properties.type.state.name) {
										case 'base': {
											const $_base__type__state_group = $_state_group.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_type = raw_data
											break;
										}
										case 'derived': {
											const $_derived__type__state_group = $_state_group.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_value_source: Record<string, any>;
												switch ($_derived__type__state_group.properties.value_source.state.name) {
													case 'expression': {
														const $_expression__value_source__derived__type__state_group = $_derived__type__state_group.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["expression"] = serialize_derivation_expression($_expression__value_source__derived__type__state_group.properties.expression);
														raw_data["recursion"] = serialize_recursion_annotation($_expression__value_source__derived__type__state_group.properties.recursion);
														raw_value_source = raw_data
														break;
													}
													case 'parameter': {
														const $_parameter__value_source__derived__type__state_group = $_derived__type__state_group.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_value_source = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_derived__type__state_group.properties.value_source.state)
												}
												raw_data["value source"] = [$_derived__type__state_group.properties.value_source.state.name, raw_value_source];
											}
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_state_group.properties.type.state)
									}
									raw_data["type"] = [$_state_group.properties.type.state.name, raw_type];
								}
								raw_data["ui"] = serialize_ui_state_group_property($_state_group.properties.ui);
								raw_type = raw_data
								break;
							}
							case 'text': {
								const $_text__type__property = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_has_reference: Record<string, any>;
									switch ($_text__type__property.properties.has_reference.state.name) {
										case 'no': {
											const $_no__has_reference = $_text__type__property.properties.has_reference.state.node;
											const raw_data: Record<string, any> = {};
											raw_has_reference = raw_data
											break;
										}
										case 'yes': {
											const $_yes__has_reference = $_text__type__property.properties.has_reference.state.node;
											const raw_data: Record<string, any> = {};
											raw_data["assignment"] = serialize_optional_named_object_assignment($_yes__has_reference.properties.assignment);
											raw_data["behaviour"] = serialize_reference_behaviour($_yes__has_reference.properties.behaviour);
											{
												let raw_behaviour_specialization: Record<string, any>;
												switch ($_yes__has_reference.properties.behaviour_specialization.state.name) {
													case 'none': {
														const $_none__behaviour_specialization = $_yes__has_reference.properties.behaviour_specialization.state.node;
														const raw_data: Record<string, any> = {};
														raw_behaviour_specialization = raw_data
														break;
													}
													case 'propagate key to value': {
														const $_propagate_key_to_value = $_yes__has_reference.properties.behaviour_specialization.state.node;
														const raw_data: Record<string, any> = {};
														raw_behaviour_specialization = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_yes__has_reference.properties.behaviour_specialization.state)
												}
												raw_data["behaviour specialization"] = [$_yes__has_reference.properties.behaviour_specialization.state.name, raw_behaviour_specialization];
											}
											raw_data["direction"] = serialize_direction_annotation($_yes__has_reference.properties.direction);
											raw_data["expression"] = serialize_entry_reference_definition($_yes__has_reference.properties.expression);
											raw_data["recursion"] = serialize_recursion_annotation($_yes__has_reference.properties.recursion);
											raw_data["rules"] = serialize_where_rules_definition($_yes__has_reference.properties.rules);
											raw_data["ui"] = serialize_ui_reference_rule($_yes__has_reference.properties.ui);
											raw_has_reference = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.has_reference.state)
									}
									raw_data["has reference"] = [$_text__type__property.properties.has_reference.state.name, raw_has_reference];
								}
								{
									let raw_type: Record<string, any>;
									switch ($_text__type__property.properties.type.state.name) {
										case 'base': {
											const $_base__type__text = $_text__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											raw_type = raw_data
											break;
										}
										case 'derived': {
											const $_derived__type__text = $_text__type__property.properties.type.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_value_source: Record<string, any>;
												switch ($_derived__type__text.properties.value_source.state.name) {
													case 'derived key': {
														const $_derived_key = $_derived__type__text.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_value_source = raw_data
														break;
													}
													case 'expression': {
														const $_expression__value_source__derived__type__text = $_derived__type__text.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_data["expression"] = serialize_derivation_expression($_expression__value_source__derived__type__text.properties.expression);
														raw_data["recursion"] = serialize_recursion_annotation($_expression__value_source__derived__type__text.properties.recursion);
														raw_value_source = raw_data
														break;
													}
													case 'parameter': {
														const $_parameter__value_source__derived__type__text = $_derived__type__text.properties.value_source.state.node;
														const raw_data: Record<string, any> = {};
														raw_value_source = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_derived__type__text.properties.value_source.state)
												}
												raw_data["value source"] = [$_derived__type__text.properties.value_source.state.name, raw_value_source];
											}
											raw_type = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property.properties.type.state)
									}
									raw_data["type"] = [$_text__type__property.properties.type.state.name, raw_type];
								}
								raw_data["ui"] = serialize_ui_text_property($_text__type__property.properties.ui);
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_property__type__attributes.properties.type.state)
						}
						raw_data["type"] = [$_property__type__attributes.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				case 'reference set': {
					const $_reference_set__type__attributes = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["direction"] = serialize_direction_annotation($_reference_set__type__attributes.properties.direction);
					raw_data["recursion"] = serialize_recursion_annotation($_reference_set__type__attributes.properties.recursion);
					let raw_referenced_type_path: Record<string, any>;
					{
						const $_referenced_type_path = $_reference_set__type__attributes.properties.referenced_type_path;
						const raw_data: Record<string, any> = {};
						raw_data["head"] = serialize_object_path_tail($_referenced_type_path.properties.head);
						raw_data["path"] = serialize_plural_object_path_tail($_referenced_type_path.properties.path);
						{
							let raw_root: Record<string, any>;
							switch ($_referenced_type_path.properties.root.state.name) {
								case 'context': {
									const $_context = $_referenced_type_path.properties.root.state.node;
									const raw_data: Record<string, any> = {};
									raw_root = raw_data
									break;
								}
								case 'sibling': {
									const $_sibling__root = $_referenced_type_path.properties.root.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["definition"] = serialize_sibling_reference_definition($_sibling__root.properties.definition);
									raw_root = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_referenced_type_path.properties.root.state)
							}
							raw_data["root"] = [$_referenced_type_path.properties.root.state.name, raw_root];
						}
						raw_referenced_type_path = raw_data
					}
					raw_data["referenced type path"] = raw_referenced_type_path;
					raw_data["ui"] = serialize_ui_reference_set_attribute($_reference_set__type__attributes.properties.ui);
					{
						let raw_value_source: Record<string, any>;
						switch ($_reference_set__type__attributes.properties.value_source.state.name) {
							case 'reference': {
								const $_reference__value_source = $_reference_set__type__attributes.properties.value_source.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["reference"] = serialize_dependency_step($_reference__value_source.properties.reference);
								raw_value_source = raw_data
								break;
							}
							case 'union branch': {
								const $_union_branch = $_reference_set__type__attributes.properties.value_source.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["branch"] = $_union_branch.properties.branch.entry;
								raw_value_source = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_reference_set__type__attributes.properties.value_source.state)
						}
						raw_data["value source"] = [$_reference_set__type__attributes.properties.value_source.state.name, raw_value_source];
					}
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_attributes.properties.type.state)
			}
			raw_data["type"] = [$_attributes.properties.type.state.name, raw_type];
		}
		raw_attributes[k] = raw_data
	}
	raw_data["attributes"] = raw_attributes;
	{
		let raw_has_attributes: Record<string, any>;
		switch ($_node__application.properties.has_attributes.state.name) {
			case 'no': {
				const $_no__has_attributes = $_node__application.properties.has_attributes.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_attributes = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_attributes = $_node__application.properties.has_attributes.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["first"] = $_yes__has_attributes.properties.first.entry;
				raw_data["last"] = $_yes__has_attributes.properties.last.entry;
				raw_has_attributes = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node__application.properties.has_attributes.state)
		}
		raw_data["has attributes"] = [$_node__application.properties.has_attributes.state.name, raw_has_attributes];
	}
	raw_data["permissions definition"] = serialize_node_permissions_definition($_node__application.properties.permissions_definition);
	raw_data["todo definition"] = serialize_todo_definition($_node__application.properties.todo_definition);
	return raw_data;
}
function serialize_node_expression($_node_expression: read_api.Cnode_expression) {
	const raw_data: Record<string, any> = {};
	raw_data["node path"] = serialize_conditional_node_path($_node_expression.properties.node_path);
	{
		let raw_type: Record<string, any>;
		switch ($_node_expression.properties.type.state.name) {
			case 'containment': {
				const $_containment__type__node_expression = $_node_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["collection"] = $_containment__type__node_expression.properties.collection.entry;
				let raw_key_path: Record<string, any>;
				{
					const $_key_path = $_containment__type__node_expression.properties.key_path;
					const raw_data: Record<string, any> = {};
					raw_data["path"] = serialize_conditional_node_path($_key_path.properties.path);
					raw_data["text"] = $_key_path.properties.text.entry;
					raw_key_path = raw_data
				}
				raw_data["key path"] = raw_key_path;
				raw_type = raw_data
				break;
			}
			case 'equality': {
				const $_equality__type__node_expression = $_node_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expected node path"] = serialize_conditional_node_path($_equality__type__node_expression.properties.expected_node_path);
				raw_type = raw_data
				break;
			}
			case 'existence': {
				const $_existence__type__node_expression = $_node_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node_expression.properties.type.state)
		}
		raw_data["type"] = [$_node_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_node_initializer($_node_initializer: read_api.Cnode_initializer) {
	const raw_data: Record<string, any> = {};
	const raw_arguments: Record<string, any> = {};
	for (let [k,v] of $_node_initializer.properties.arguments) {
		const $_arguments = v;
		const raw_data: Record<string, any> = {};
		raw_data["expression"] = serialize_derivation_expression($_arguments.properties.expression);
		raw_arguments[k] = raw_data
	}
	raw_data["arguments"] = raw_arguments;
	return raw_data;
}
function serialize_node_path($_node_path: read_api.Cnode_path) {
	const raw_data: Record<string, any> = {};
	raw_data["head"] = serialize_context_node_path($_node_path.properties.head);
	raw_data["tail"] = serialize_node_path_tail($_node_path.properties.tail);
	return raw_data;
}
function serialize_node_path_tail($_node_path_tail: read_api.Cnode_path_tail) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_node_path_tail.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__node_path_tail = $_node_path_tail.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__node_path_tail = $_node_path_tail.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["step"] = serialize_node_step($_yes__has_steps__node_path_tail.properties.step);
				raw_data["tail"] = serialize_node_path_tail($_yes__has_steps__node_path_tail.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node_path_tail.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_node_path_tail.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_node_permissions_definition($_node_permissions_definition: read_api.Cnode_permissions_definition) {
	const raw_data: Record<string, any> = {};
	{
		let raw_read_permission: Record<string, any>;
		switch ($_node_permissions_definition.properties.read_permission.state.name) {
			case 'explicit': {
				const $_explicit__read_permission = $_node_permissions_definition.properties.read_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["permission"] = serialize_permission($_explicit__read_permission.properties.permission);
				raw_read_permission = raw_data
				break;
			}
			case 'inherited': {
				const $_inherited__read_permission = $_node_permissions_definition.properties.read_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_read_permission = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node_permissions_definition.properties.read_permission.state)
		}
		raw_data["read permission"] = [$_node_permissions_definition.properties.read_permission.state.name, raw_read_permission];
	}
	{
		let raw_update_permission: Record<string, any>;
		switch ($_node_permissions_definition.properties.update_permission.state.name) {
			case 'explicit': {
				const $_explicit__update_permission = $_node_permissions_definition.properties.update_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["permission"] = serialize_permission($_explicit__update_permission.properties.permission);
				raw_update_permission = raw_data
				break;
			}
			case 'inherited': {
				const $_inherited__update_permission = $_node_permissions_definition.properties.update_permission.state.node;
				const raw_data: Record<string, any> = {};
				raw_update_permission = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node_permissions_definition.properties.update_permission.state)
		}
		raw_data["update permission"] = [$_node_permissions_definition.properties.update_permission.state.name, raw_update_permission];
	}
	return raw_data;
}
function serialize_node_step($_node_step__application: read_api.Cnode_step__application) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_node_step__application.properties.type.state.name) {
			case 'group': {
				const $_group__type__node_step = $_node_step__application.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["group"] = $_group__type__node_step.properties.group.entry;
				raw_type = raw_data
				break;
			}
			case 'parent': {
				const $_parent__type__node_step = $_node_step__application.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'property rule': {
				const $_property_rule = $_node_step__application.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["rule"] = $_property_rule.properties.rule.entry;
				raw_data["text"] = $_property_rule.properties.text.entry;
				raw_type = raw_data
				break;
			}
			case 'reference': {
				const $_reference__type__node_step = $_node_step__application.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["text"] = $_reference__type__node_step.properties.text.entry;
				raw_type = raw_data
				break;
			}
			case 'state': {
				const $_state__type__node_step = $_node_step__application.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["state"] = $_state__type__node_step.properties.state.entry;
				raw_data["state group"] = $_state__type__node_step.properties.state_group.entry;
				raw_type = raw_data
				break;
			}
			case 'state context rule': {
				const $_state_context_rule__type__node_step = $_node_step__application.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["rule"] = $_state_context_rule__type__node_step.properties.rule.entry;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node_step__application.properties.type.state)
		}
		raw_data["type"] = [$_node_step__application.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_node_type_id($_node_type_id: read_api.Cnode_type_id) {
	const raw_data: Record<string, any> = {};
	raw_data["steps"] = serialize_node_type_id_path($_node_type_id.properties.steps);
	return raw_data;
}
function serialize_node_type_id_path($_node_type_id_path: read_api.Cnode_type_id_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_node_type_id_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__node_type_id_path = $_node_type_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__node_type_id_path = $_node_type_id_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["property"] = $_yes__has_steps__node_type_id_path.properties.property.entry;
				raw_data["tail"] = serialize_node_type_id_path($_yes__has_steps__node_type_id_path.properties.tail);
				{
					let raw_value_type: Record<string, any>;
					switch ($_yes__has_steps__node_type_id_path.properties.value_type.state.name) {
						case 'choice': {
							const $_choice__value_type__yes__has_steps__node_type_id_path = $_yes__has_steps__node_type_id_path.properties.value_type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_choice__value_type__yes__has_steps__node_type_id_path.properties.state.entry;
							raw_value_type = raw_data
							break;
						}
						case 'collection': {
							const $_collection__value_type__yes__has_steps__node_type_id_path = $_yes__has_steps__node_type_id_path.properties.value_type.state.node;
							const raw_data: Record<string, any> = {};
							raw_value_type = raw_data
							break;
						}
						case 'node': {
							const $_node__value_type__yes__has_steps__node_type_id_path = $_yes__has_steps__node_type_id_path.properties.value_type.state.node;
							const raw_data: Record<string, any> = {};
							raw_value_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__node_type_id_path.properties.value_type.state)
					}
					raw_data["value type"] = [$_yes__has_steps__node_type_id_path.properties.value_type.state.name, raw_value_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node_type_id_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_node_type_id_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_number_expression($_number_expression: read_api.Cnumber_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_number_expression.properties.type.state.name) {
			case 'aggregate': {
				const $_aggregate = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_aggregate.properties.type.state.name) {
						case 'addition': {
							const $_addition = $_aggregate.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["left"] = serialize_unary_number_expression($_addition.properties.left);
							raw_data["right"] = serialize_unary_number_expression($_addition.properties.right);
							raw_type = raw_data
							break;
						}
						case 'collection operation': {
							const $_collection_operation = $_aggregate.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_type: Record<string, any>;
								switch ($_collection_operation.properties.type.state.name) {
									case 'count': {
										const $_count = $_collection_operation.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["nodes path"] = serialize_object_set_path($_count.properties.nodes_path);
										raw_type = raw_data
										break;
									}
									case 'property': {
										const $_property__type__collection_operation = $_collection_operation.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["numbers path"] = serialize_object_set_path($_property__type__collection_operation.properties.numbers_path);
										{
											let raw_operation: Record<string, any>;
											switch ($_property__type__collection_operation.properties.operation.state.name) {
												case 'maximum': {
													const $_maximum__operation__property = $_property__type__collection_operation.properties.operation.state.node;
													const raw_data: Record<string, any> = {};
													raw_operation = raw_data
													break;
												}
												case 'minimum': {
													const $_minimum__operation__property = $_property__type__collection_operation.properties.operation.state.node;
													const raw_data: Record<string, any> = {};
													raw_operation = raw_data
													break;
												}
												case 'standard deviation': {
													const $_standard_deviation = $_property__type__collection_operation.properties.operation.state.node;
													const raw_data: Record<string, any> = {};
													raw_operation = raw_data
													break;
												}
												case 'sum': {
													const $_sum__operation__property = $_property__type__collection_operation.properties.operation.state.node;
													const raw_data: Record<string, any> = {};
													raw_operation = raw_data
													break;
												}
												default:
													throw new Error("unexpected state: " + $_property__type__collection_operation.properties.operation.state)
											}
											raw_data["operation"] = [$_property__type__collection_operation.properties.operation.state.name, raw_operation];
										}
										raw_type = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_collection_operation.properties.type.state)
								}
								raw_data["type"] = [$_collection_operation.properties.type.state.name, raw_type];
							}
							raw_type = raw_data
							break;
						}
						case 'difference': {
							const $_difference = $_aggregate.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							let raw_expressions: Record<string, any>;
							{
								const $_expressions__difference = $_difference.properties.expressions;
								const raw_data: Record<string, any> = {};
								raw_data["left"] = serialize_unary_number_expression($_expressions__difference.properties.left);
								raw_data["right"] = serialize_unary_number_expression($_expressions__difference.properties.right);
								raw_expressions = raw_data
							}
							raw_data["expressions"] = raw_expressions;
							raw_data["scale type"] = $_difference.properties.scale_type.entry;
							raw_type = raw_data
							break;
						}
						case 'division': {
							const $_division__type = $_aggregate.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							let raw_expressions: Record<string, any>;
							{
								const $_expressions__division = $_division__type.properties.expressions;
								const raw_data: Record<string, any> = {};
								raw_data["conversion rule"] = $_expressions__division.properties.conversion_rule.entry;
								raw_data["denominator"] = serialize_unary_number_expression($_expressions__division.properties.denominator);
								raw_data["numerator"] = serialize_unary_number_expression($_expressions__division.properties.numerator);
								raw_expressions = raw_data
							}
							raw_data["expressions"] = raw_expressions;
							{
								let raw_rounding: Record<string, any>;
								switch ($_division__type.properties.rounding.state.name) {
									case 'ceil': {
										const $_ceil__rounding__division__type = $_division__type.properties.rounding.state.node;
										const raw_data: Record<string, any> = {};
										raw_rounding = raw_data
										break;
									}
									case 'floor': {
										const $_floor__rounding__division__type = $_division__type.properties.rounding.state.node;
										const raw_data: Record<string, any> = {};
										raw_rounding = raw_data
										break;
									}
									case 'ordinary': {
										const $_ordinary__rounding__division__type = $_division__type.properties.rounding.state.node;
										const raw_data: Record<string, any> = {};
										raw_rounding = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_division__type.properties.rounding.state)
								}
								raw_data["rounding"] = [$_division__type.properties.rounding.state.name, raw_rounding];
							}
							raw_type = raw_data
							break;
						}
						case 'list operation': {
							const $_list_operation = $_aggregate.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["numbers"] = serialize_derivation_expression_list($_list_operation.properties.numbers);
							{
								let raw_operation: Record<string, any>;
								switch ($_list_operation.properties.operation.state.name) {
									case 'maximum': {
										const $_maximum__operation__list_operation = $_list_operation.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'minimum': {
										const $_minimum__operation__list_operation = $_list_operation.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'sum': {
										const $_sum__operation__list_operation = $_list_operation.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_list_operation.properties.operation.state)
								}
								raw_data["operation"] = [$_list_operation.properties.operation.state.name, raw_operation];
							}
							raw_type = raw_data
							break;
						}
						case 'product': {
							const $_product__type = $_aggregate.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["conversion rule"] = $_product__type.properties.conversion_rule.entry;
							raw_data["left"] = serialize_unary_number_expression($_product__type.properties.left);
							raw_data["right"] = serialize_unary_number_expression($_product__type.properties.right);
							raw_type = raw_data
							break;
						}
						case 'remainder': {
							const $_remainder__type = $_aggregate.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["denominator"] = serialize_unary_number_expression($_remainder__type.properties.denominator);
							raw_data["numerator"] = serialize_unary_number_expression($_remainder__type.properties.numerator);
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_aggregate.properties.type.state)
					}
					raw_data["type"] = [$_aggregate.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			case 'constant': {
				const $_constant__type__number_expression = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["value"] = serialize_constant_number_value($_constant__type__number_expression.properties.value);
				raw_type = raw_data
				break;
			}
			case 'unary': {
				const $_unary__type = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expression"] = serialize_derivation_expression_tail($_unary__type.properties.expression);
				{
					let raw_type: Record<string, any>;
					switch ($_unary__type.properties.type.state.name) {
						case 'absolute value': {
							const $_absolute_value__type__unary = $_unary__type.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'numerical type conversion': {
							const $_numerical_type_conversion__type__unary = $_unary__type.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["conversion"] = $_numerical_type_conversion__type__unary.properties.conversion.entry;
							raw_type = raw_data
							break;
						}
						case 'sign inversion': {
							const $_sign_inversion__type__unary = $_unary__type.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_unary__type.properties.type.state)
					}
					raw_data["type"] = [$_unary__type.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_number_expression.properties.type.state)
		}
		raw_data["type"] = [$_number_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_object_path_tail($_object_path_tail: read_api.Cobject_path_tail) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_object_path_tail.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__object_path_tail = $_object_path_tail.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__object_path_tail = $_object_path_tail.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_object_path_tail($_yes__has_steps__object_path_tail.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__object_path_tail.properties.type.state.name) {
						case 'dependency': {
							const $_dependency__type = $_yes__has_steps__object_path_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["dependency"] = serialize_dependency_step($_dependency__type.properties.dependency);
							raw_type = raw_data
							break;
						}
						case 'parent': {
							const $_parent__type__yes = $_yes__has_steps__object_path_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'property value': {
							const $_property_value = $_yes__has_steps__object_path_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["property"] = serialize_property_step($_property_value.properties.property);
							raw_type = raw_data
							break;
						}
						case 'reference set': {
							const $_reference_set__type__yes = $_yes__has_steps__object_path_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["step"] = serialize_reference_set_step($_reference_set__type__yes.properties.step);
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state__type__yes = $_yes__has_steps__object_path_tail.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state__type__yes.properties.state.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__object_path_tail.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__object_path_tail.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_object_path_tail.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_object_path_tail.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_object_set_path($_object_set_path: read_api.Cobject_set_path) {
	const raw_data: Record<string, any> = {};
	raw_data["collection path"] = serialize_singular_variablized_object_path($_object_set_path.properties.collection_path);
	raw_data["value path"] = serialize_object_path_tail($_object_set_path.properties.value_path);
	return raw_data;
}
function serialize_optional_named_object_assignment($_optional_named_object_assignment: read_api.Coptional_named_object_assignment) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_assignment: Record<string, any>;
		switch ($_optional_named_object_assignment.properties.has_assignment.state.name) {
			case 'no': {
				const $_no__has_assignment__optional_named_object_assignment = $_optional_named_object_assignment.properties.has_assignment.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_assignment = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_assignment__optional_named_object_assignment = $_optional_named_object_assignment.properties.has_assignment.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["assignment"] = serialize_named_object_assignment($_yes__has_assignment__optional_named_object_assignment.properties.assignment);
				raw_has_assignment = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_optional_named_object_assignment.properties.has_assignment.state)
		}
		raw_data["has assignment"] = [$_optional_named_object_assignment.properties.has_assignment.state.name, raw_has_assignment];
	}
	return raw_data;
}
function serialize_optional_variable_assignment($_optional_variable_assignment: read_api.Coptional_variable_assignment) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_assignment: Record<string, any>;
		switch ($_optional_variable_assignment.properties.has_assignment.state.name) {
			case 'no': {
				const $_no__has_assignment__optional_variable_assignment = $_optional_variable_assignment.properties.has_assignment.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_assignment = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_assignment__optional_variable_assignment = $_optional_variable_assignment.properties.has_assignment.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["assignment"] = serialize_variable_assignment($_yes__has_assignment__optional_variable_assignment.properties.assignment);
				raw_has_assignment = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_optional_variable_assignment.properties.has_assignment.state)
		}
		raw_data["has assignment"] = [$_optional_variable_assignment.properties.has_assignment.state.name, raw_has_assignment];
	}
	return raw_data;
}
function serialize_password_initializer($_password_initializer: read_api.Cpassword_initializer) {
	const raw_data: Record<string, any> = {};
	raw_data["initializer"] = serialize_command_object_expression($_password_initializer.properties.initializer);
	return raw_data;
}
function serialize_permission($_permission: read_api.Cpermission) {
	const raw_data: Record<string, any> = {};
	{
		let raw_source: Record<string, any>;
		switch ($_permission.properties.source.state.name) {
			case 'imported interface': {
				const $_imported_interface = $_permission.properties.source.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["interface"] = $_imported_interface.properties.interface_.entry;
				raw_source = raw_data
				break;
			}
			case 'user': {
				const $_user__source = $_permission.properties.source.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["requirement"] = serialize_user_requirement($_user__source.properties.requirement);
				raw_source = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_permission.properties.source.state)
		}
		raw_data["source"] = [$_permission.properties.source.state.name, raw_source];
	}
	return raw_data;
}
function serialize_plural_descendant_node_path($_plural_descendant_node_path: read_api.Cplural_descendant_node_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_plural_descendant_node_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__plural_descendant_node_path = $_plural_descendant_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__plural_descendant_node_path = $_plural_descendant_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["property"] = serialize_property_step($_yes__has_steps__plural_descendant_node_path.properties.property);
				raw_data["tail"] = serialize_plural_descendant_node_path($_yes__has_steps__plural_descendant_node_path.properties.tail);
				{
					let raw_value_type: Record<string, any>;
					switch ($_yes__has_steps__plural_descendant_node_path.properties.value_type.state.name) {
						case 'choice': {
							const $_choice__value_type__yes__has_steps__plural_descendant_node_path = $_yes__has_steps__plural_descendant_node_path.properties.value_type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_choice__value_type__yes__has_steps__plural_descendant_node_path.properties.state.entry;
							raw_value_type = raw_data
							break;
						}
						case 'collection': {
							const $_collection__value_type__yes__has_steps__plural_descendant_node_path = $_yes__has_steps__plural_descendant_node_path.properties.value_type.state.node;
							const raw_data: Record<string, any> = {};
							raw_value_type = raw_data
							break;
						}
						case 'node': {
							const $_node__value_type__yes__has_steps__plural_descendant_node_path = $_yes__has_steps__plural_descendant_node_path.properties.value_type.state.node;
							const raw_data: Record<string, any> = {};
							raw_value_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__plural_descendant_node_path.properties.value_type.state)
					}
					raw_data["value type"] = [$_yes__has_steps__plural_descendant_node_path.properties.value_type.state.name, raw_value_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_plural_descendant_node_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_plural_descendant_node_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_plural_object_path($_plural_object_path: read_api.Cplural_object_path) {
	const raw_data: Record<string, any> = {};
	raw_data["head"] = serialize_variablized_object_path($_plural_object_path.properties.head);
	raw_data["path"] = serialize_plural_object_path_tail($_plural_object_path.properties.path);
	return raw_data;
}
function serialize_plural_object_path_tail($_plural_object_path_tail: read_api.Cplural_object_path_tail) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_plural_object_path_tail.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__plural_object_path_tail = $_plural_object_path_tail.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__plural_object_path_tail = $_plural_object_path_tail.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["path"] = serialize_object_path_tail($_yes__has_steps__plural_object_path_tail.properties.path);
				raw_data["tail"] = serialize_plural_object_path_tail($_yes__has_steps__plural_object_path_tail.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_plural_object_path_tail.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_plural_object_path_tail.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_plural_reference_expression($_plural_reference_expression: read_api.Cplural_reference_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_plural_reference_expression.properties.type.state.name) {
			case 'augment': {
				const $_augment = $_plural_reference_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["collection path"] = serialize_variablized_object_path($_augment.properties.collection_path);
				raw_data["filter path"] = serialize_descendant_object_path($_augment.properties.filter_path);
				raw_type = raw_data
				break;
			}
			case 'union': {
				const $_union = $_plural_reference_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_branches: Record<string, any> = {};
				for (let [k,v] of $_union.properties.branches) {
					const $_branches__union = v;
					const raw_data: Record<string, any> = {};
					{
						let raw_has_predecessor: Record<string, any>;
						switch ($_branches__union.properties.has_predecessor.state.name) {
							case 'no': {
								const $_no__has_predecessor__branches = $_branches__union.properties.has_predecessor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_predecessor = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_predecessor__branches = $_branches__union.properties.has_predecessor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_predecessor = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_branches__union.properties.has_predecessor.state)
						}
						raw_data["has predecessor"] = [$_branches__union.properties.has_predecessor.state.name, raw_has_predecessor];
					}
					{
						let raw_has_successor: Record<string, any>;
						switch ($_branches__union.properties.has_successor.state.name) {
							case 'no': {
								const $_no__has_successor__branches = $_branches__union.properties.has_successor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_successor = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_successor__branches = $_branches__union.properties.has_successor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_successor = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_branches__union.properties.has_successor.state)
						}
						raw_data["has successor"] = [$_branches__union.properties.has_successor.state.name, raw_has_successor];
					}
					{
						let raw_source: Record<string, any>;
						switch ($_branches__union.properties.source.state.name) {
							case 'dependency': {
								const $_dependency__source = $_branches__union.properties.source.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["dependency"] = serialize_dependency_step($_dependency__source.properties.dependency);
								raw_data["path"] = serialize_plural_object_path($_dependency__source.properties.path);
								raw_source = raw_data
								break;
							}
							case 'dependency inversion': {
								const $_dependency_inversion = $_branches__union.properties.source.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["reference set path"] = serialize_variablized_object_path($_dependency_inversion.properties.reference_set_path);
								raw_data["subset path"] = serialize_reference_set_subset_step($_dependency_inversion.properties.subset_path);
								raw_source = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_branches__union.properties.source.state)
						}
						raw_data["source"] = [$_branches__union.properties.source.state.name, raw_source];
					}
					raw_branches[k] = raw_data
				}
				raw_data["branches"] = raw_branches;
				raw_data["first branch"] = $_union.properties.first_branch.entry;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_plural_reference_expression.properties.type.state)
		}
		raw_data["type"] = [$_plural_reference_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_property_step($_property_step: read_api.Cproperty_step) {
	const raw_data: Record<string, any> = {};
	raw_data["property"] = $_property_step.properties.property.entry;
	return raw_data;
}
function serialize_recursion_annotation($_recursion_annotation: read_api.Crecursion_annotation) {
	const raw_data: Record<string, any> = {};
	{
		let raw_recursive_graph_traversal: Record<string, any>;
		switch ($_recursion_annotation.properties.recursive_graph_traversal.state.name) {
			case 'no': {
				const $_no__recursive_graph_traversal = $_recursion_annotation.properties.recursive_graph_traversal.state.node;
				const raw_data: Record<string, any> = {};
				raw_recursive_graph_traversal = raw_data
				break;
			}
			case 'yes': {
				const $_yes__recursive_graph_traversal = $_recursion_annotation.properties.recursive_graph_traversal.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["selector"] = serialize_graph_traversal_selector($_yes__recursive_graph_traversal.properties.selector);
				raw_recursive_graph_traversal = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_recursion_annotation.properties.recursive_graph_traversal.state)
		}
		raw_data["recursive graph traversal"] = [$_recursion_annotation.properties.recursive_graph_traversal.state.name, raw_recursive_graph_traversal];
	}
	return raw_data;
}
function serialize_reference_behaviour($_reference_behaviour: read_api.Creference_behaviour) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_reference_behaviour.properties.type.state.name) {
			case 'mandatory': {
				const $_mandatory__type = $_reference_behaviour.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'optional': {
				const $_optional__type = $_reference_behaviour.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_reference_behaviour.properties.type.state)
		}
		raw_data["type"] = [$_reference_behaviour.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_reference_set_step($_reference_set_step: read_api.Creference_set_step) {
	const raw_data: Record<string, any> = {};
	raw_data["reference set"] = $_reference_set_step.properties.reference_set.entry;
	return raw_data;
}
function serialize_reference_set_subset_step($_reference_set_subset_step: read_api.Creference_set_subset_step) {
	const raw_data: Record<string, any> = {};
	{
		let raw_subset: Record<string, any>;
		switch ($_reference_set_subset_step.properties.subset.state.name) {
			case 'no': {
				const $_no__subset = $_reference_set_subset_step.properties.subset.state.node;
				const raw_data: Record<string, any> = {};
				raw_subset = raw_data
				break;
			}
			case 'yes': {
				const $_yes__subset = $_reference_set_subset_step.properties.subset.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["head"] = serialize_variablized_object_path($_yes__subset.properties.head);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__subset.properties.type.state.name) {
						case 'sibling': {
							const $_sibling__type__yes = $_yes__subset.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'simple': {
							const $_simple__type__yes = $_yes__subset.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__subset.properties.type.state)
					}
					raw_data["type"] = [$_yes__subset.properties.type.state.name, raw_type];
				}
				raw_subset = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_reference_set_subset_step.properties.subset.state)
		}
		raw_data["subset"] = [$_reference_set_subset_step.properties.subset.state.name, raw_subset];
	}
	return raw_data;
}
function serialize_scalar_expression($_scalar_expression: read_api.Cscalar_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_scalar_expression.properties.type.state.name) {
			case 'dynamic': {
				const $_dynamic__type__scalar_expression = $_scalar_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["path"] = serialize_singular_node_path($_dynamic__type__scalar_expression.properties.path);
				raw_data["property"] = $_dynamic__type__scalar_expression.properties.property.entry;
				raw_type = raw_data
				break;
			}
			case 'number': {
				const $_number__type__scalar_expression = $_scalar_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_number__type__scalar_expression.properties.type.state.name) {
						case 'binary expression': {
							const $_binary_expression__type__number__type__scalar_expression = $_number__type__scalar_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							let raw_expressions: Record<string, any>;
							{
								const $_expressions__binary_expression__type__number__type__scalar_expression = $_binary_expression__type__number__type__scalar_expression.properties.expressions;
								const raw_data: Record<string, any> = {};
								raw_data["left"] = serialize_scalar_expression($_expressions__binary_expression__type__number__type__scalar_expression.properties.left);
								raw_data["right"] = serialize_scalar_expression($_expressions__binary_expression__type__number__type__scalar_expression.properties.right);
								raw_expressions = raw_data
							}
							raw_data["expressions"] = raw_expressions;
							{
								let raw_operation: Record<string, any>;
								switch ($_binary_expression__type__number__type__scalar_expression.properties.operation.state.name) {
									case 'division': {
										const $_division__operation__binary_expression__type__number__type__scalar_expression = $_binary_expression__type__number__type__scalar_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										{
											let raw_rounding: Record<string, any>;
											switch ($_division__operation__binary_expression__type__number__type__scalar_expression.properties.rounding.state.name) {
												case 'ceil': {
													const $_ceil__rounding__division__operation__binary_expression__type__number__type__scalar_expression = $_division__operation__binary_expression__type__number__type__scalar_expression.properties.rounding.state.node;
													const raw_data: Record<string, any> = {};
													raw_rounding = raw_data
													break;
												}
												case 'floor': {
													const $_floor__rounding__division__operation__binary_expression__type__number__type__scalar_expression = $_division__operation__binary_expression__type__number__type__scalar_expression.properties.rounding.state.node;
													const raw_data: Record<string, any> = {};
													raw_rounding = raw_data
													break;
												}
												case 'ordinary': {
													const $_ordinary__rounding__division__operation__binary_expression__type__number__type__scalar_expression = $_division__operation__binary_expression__type__number__type__scalar_expression.properties.rounding.state.node;
													const raw_data: Record<string, any> = {};
													raw_rounding = raw_data
													break;
												}
												default:
													throw new Error("unexpected state: " + $_division__operation__binary_expression__type__number__type__scalar_expression.properties.rounding.state)
											}
											raw_data["rounding"] = [$_division__operation__binary_expression__type__number__type__scalar_expression.properties.rounding.state.name, raw_rounding];
										}
										raw_operation = raw_data
										break;
									}
									case 'remainder': {
										const $_remainder__operation__binary_expression__type__number__type__scalar_expression = $_binary_expression__type__number__type__scalar_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_binary_expression__type__number__type__scalar_expression.properties.operation.state)
								}
								raw_data["operation"] = [$_binary_expression__type__number__type__scalar_expression.properties.operation.state.name, raw_operation];
							}
							raw_type = raw_data
							break;
						}
						case 'constant': {
							const $_constant__type__number__type__scalar_expression = $_number__type__scalar_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["value"] = serialize_constant_number_value($_constant__type__number__type__scalar_expression.properties.value);
							raw_type = raw_data
							break;
						}
						case 'list expression': {
							const $_list_expression__type__number__type__scalar_expression = $_number__type__scalar_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_scalar_expression_list($_list_expression__type__number__type__scalar_expression.properties.expression);
							{
								let raw_operation: Record<string, any>;
								switch ($_list_expression__type__number__type__scalar_expression.properties.operation.state.name) {
									case 'maximum': {
										const $_maximum__operation__list_expression__type__number__type__scalar_expression = $_list_expression__type__number__type__scalar_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'minimum': {
										const $_minimum__operation__list_expression__type__number__type__scalar_expression = $_list_expression__type__number__type__scalar_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'product': {
										const $_product__operation__list_expression__type__number__type__scalar_expression = $_list_expression__type__number__type__scalar_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'sum': {
										const $_sum__operation__list_expression__type__number__type__scalar_expression = $_list_expression__type__number__type__scalar_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_list_expression__type__number__type__scalar_expression.properties.operation.state)
								}
								raw_data["operation"] = [$_list_expression__type__number__type__scalar_expression.properties.operation.state.name, raw_operation];
							}
							raw_type = raw_data
							break;
						}
						case 'now in seconds': {
							const $_now_in_seconds__type__number__type__scalar_expression = $_number__type__scalar_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'unary expression': {
							const $_unary_expression__type__number__type__scalar_expression = $_number__type__scalar_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_scalar_expression($_unary_expression__type__number__type__scalar_expression.properties.expression);
							{
								let raw_type: Record<string, any>;
								switch ($_unary_expression__type__number__type__scalar_expression.properties.type.state.name) {
									case 'absolute value': {
										const $_absolute_value__type__unary_expression__type__number__type__scalar_expression = $_unary_expression__type__number__type__scalar_expression.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_type = raw_data
										break;
									}
									case 'numerical type conversion': {
										const $_numerical_type_conversion__type__unary_expression__type__number__type__scalar_expression = $_unary_expression__type__number__type__scalar_expression.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["conversion"] = $_numerical_type_conversion__type__unary_expression__type__number__type__scalar_expression.properties.conversion.entry;
										raw_type = raw_data
										break;
									}
									case 'sign inversion': {
										const $_sign_inversion__type__unary_expression__type__number__type__scalar_expression = $_unary_expression__type__number__type__scalar_expression.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_type = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_unary_expression__type__number__type__scalar_expression.properties.type.state)
								}
								raw_data["type"] = [$_unary_expression__type__number__type__scalar_expression.properties.type.state.name, raw_type];
							}
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_number__type__scalar_expression.properties.type.state)
					}
					raw_data["type"] = [$_number__type__scalar_expression.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			case 'text': {
				const $_text__type__scalar_expression = $_scalar_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_text__type__scalar_expression.properties.type.state.name) {
						case 'static': {
							const $_static__type__text__type__scalar_expression = $_text__type__scalar_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["value"] = $_static__type__text__type__scalar_expression.properties.value;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_text__type__scalar_expression.properties.type.state)
					}
					raw_data["type"] = [$_text__type__scalar_expression.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_scalar_expression.properties.type.state)
		}
		raw_data["type"] = [$_scalar_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_scalar_expression_list($_scalar_expression_list: read_api.Cscalar_expression_list) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_tail: Record<string, any>;
		switch ($_scalar_expression_list.properties.has_tail.state.name) {
			case 'no': {
				const $_no__has_tail__scalar_expression_list = $_scalar_expression_list.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_tail = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_tail__scalar_expression_list = $_scalar_expression_list.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_scalar_expression_list($_yes__has_tail__scalar_expression_list.properties.tail);
				raw_has_tail = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_scalar_expression_list.properties.has_tail.state)
		}
		raw_data["has tail"] = [$_scalar_expression_list.properties.has_tail.state.name, raw_has_tail];
	}
	raw_data["head"] = serialize_scalar_expression($_scalar_expression_list.properties.head);
	return raw_data;
}
function serialize_sibling_reference_definition($_sibling_reference_definition: read_api.Csibling_reference_definition) {
	const raw_data: Record<string, any> = {};
	{
		let raw_graph_participation: Record<string, any>;
		switch ($_sibling_reference_definition.properties.graph_participation.state.name) {
			case 'no': {
				const $_no__graph_participation = $_sibling_reference_definition.properties.graph_participation.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_support_self_reference: Record<string, any>;
					switch ($_no__graph_participation.properties.support_self_reference.state.name) {
						case 'no': {
							const $_no__support_self_reference = $_no__graph_participation.properties.support_self_reference.state.node;
							const raw_data: Record<string, any> = {};
							raw_support_self_reference = raw_data
							break;
						}
						case 'yes': {
							const $_yes__support_self_reference = $_no__graph_participation.properties.support_self_reference.state.node;
							const raw_data: Record<string, any> = {};
							raw_support_self_reference = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_no__graph_participation.properties.support_self_reference.state)
					}
					raw_data["support self reference"] = [$_no__graph_participation.properties.support_self_reference.state.name, raw_support_self_reference];
				}
				raw_graph_participation = raw_data
				break;
			}
			case 'yes': {
				const $_yes__graph_participation = $_sibling_reference_definition.properties.graph_participation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["graph traversal"] = serialize_graph_traversal_definition($_yes__graph_participation.properties.graph_traversal);
				raw_graph_participation = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_sibling_reference_definition.properties.graph_participation.state)
		}
		raw_data["graph participation"] = [$_sibling_reference_definition.properties.graph_participation.state.name, raw_graph_participation];
	}
	return raw_data;
}
function serialize_singular_node_path($_singular_node_path: read_api.Csingular_node_path) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_node_path($_singular_node_path.properties.path);
	return raw_data;
}
function serialize_singular_variablized_object_path($_singular_variablized_object_path: read_api.Csingular_variablized_object_path) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_variablized_object_path($_singular_variablized_object_path.properties.path);
	return raw_data;
}
function serialize_state_initializer($_state_initializer: read_api.Cstate_initializer) {
	const raw_data: Record<string, any> = {};
	raw_data["node initializer"] = serialize_node_initializer($_state_initializer.properties.node_initializer);
	const raw_rule_arguments: Record<string, any> = {};
	for (let [k,v] of $_state_initializer.properties.rule_arguments) {
		const $_rule_arguments = v;
		const raw_data: Record<string, any> = {};
		raw_data["expression"] = serialize_derivation_expression($_rule_arguments.properties.expression);
		raw_rule_arguments[k] = raw_data
	}
	raw_data["rule arguments"] = raw_rule_arguments;
	raw_data["state"] = $_state_initializer.properties.state.entry;
	return raw_data;
}
function serialize_todo_definition($_todo_definition: read_api.Ctodo_definition) {
	const raw_data: Record<string, any> = {};
	{
		let raw_todo: Record<string, any>;
		switch ($_todo_definition.properties.todo.state.name) {
			case 'no': {
				const $_no__todo = $_todo_definition.properties.todo.state.node;
				const raw_data: Record<string, any> = {};
				raw_todo = raw_data
				break;
			}
			case 'yes': {
				const $_yes__todo = $_todo_definition.properties.todo.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["requirement"] = serialize_user_requirement($_yes__todo.properties.requirement);
				raw_data["ui"] = serialize_ui_todo($_yes__todo.properties.ui);
				raw_todo = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_todo_definition.properties.todo.state)
		}
		raw_data["todo"] = [$_todo_definition.properties.todo.state.name, raw_todo];
	}
	return raw_data;
}
function serialize_ui_action($_ui_action: read_api.Cui_action) {
	const raw_data: Record<string, any> = {};
	raw_data["expression"] = serialize_ui_expression($_ui_action.properties.expression);
	{
		let raw_has_next_action: Record<string, any>;
		switch ($_ui_action.properties.has_next_action.state.name) {
			case 'no': {
				const $_no__has_next_action = $_ui_action.properties.has_next_action.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_next_action = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_next_action = $_ui_action.properties.has_next_action.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["action"] = serialize_ui_action($_yes__has_next_action.properties.action);
				raw_has_next_action = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_action.properties.has_next_action.state)
		}
		raw_data["has next action"] = [$_ui_action.properties.has_next_action.state.name, raw_has_next_action];
	}
	return raw_data;
}
function serialize_ui_action_attribute($_ui_action_attribute: read_api.Cui_action_attribute) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_action_attribute.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_action_attribute = $_ui_action_attribute.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_action_attribute = $_ui_action_attribute.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_action_attribute.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_action_attribute.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_action_attribute.properties.has_description.state.name, raw_has_description];
	}
	return raw_data;
}
function serialize_ui_action_interaction($_ui_action_interaction: read_api.Cui_action_interaction) {
	const raw_data: Record<string, any> = {};
	{
		let raw_interactive: Record<string, any>;
		switch ($_ui_action_interaction.properties.interactive.state.name) {
			case 'no': {
				const $_no__interactive = $_ui_action_interaction.properties.interactive.state.node;
				const raw_data: Record<string, any> = {};
				raw_interactive = raw_data
				break;
			}
			case 'yes': {
				const $_yes__interactive = $_ui_action_interaction.properties.interactive.state.node;
				const raw_data: Record<string, any> = {};
				raw_interactive = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_action_interaction.properties.interactive.state)
		}
		raw_data["interactive"] = [$_ui_action_interaction.properties.interactive.state.name, raw_interactive];
	}
	return raw_data;
}
function serialize_ui_action_visualization($_ui_action_visualization: read_api.Cui_action_visualization) {
	const raw_data: Record<string, any> = {};
	{
		let raw_show_target: Record<string, any>;
		switch ($_ui_action_visualization.properties.show_target.state.name) {
			case 'no': {
				const $_no__show_target = $_ui_action_visualization.properties.show_target.state.node;
				const raw_data: Record<string, any> = {};
				raw_show_target = raw_data
				break;
			}
			case 'yes': {
				const $_yes__show_target = $_ui_action_visualization.properties.show_target.state.node;
				const raw_data: Record<string, any> = {};
				raw_show_target = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_action_visualization.properties.show_target.state)
		}
		raw_data["show target"] = [$_ui_action_visualization.properties.show_target.state.name, raw_show_target];
	}
	return raw_data;
}
function serialize_ui_collection_property($_ui_collection_property: read_api.Cui_collection_property) {
	const raw_data: Record<string, any> = {};
	{
		let raw_break_out: Record<string, any>;
		switch ($_ui_collection_property.properties.break_out.state.name) {
			case 'no': {
				const $_no__break_out__ui_collection_property = $_ui_collection_property.properties.break_out.state.node;
				const raw_data: Record<string, any> = {};
				raw_break_out = raw_data
				break;
			}
			case 'yes': {
				const $_yes__break_out__ui_collection_property = $_ui_collection_property.properties.break_out.state.node;
				const raw_data: Record<string, any> = {};
				raw_break_out = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.break_out.state)
		}
		raw_data["break out"] = [$_ui_collection_property.properties.break_out.state.name, raw_break_out];
	}
	{
		let raw_can_be_dormant: Record<string, any>;
		switch ($_ui_collection_property.properties.can_be_dormant.state.name) {
			case 'no': {
				const $_no__can_be_dormant = $_ui_collection_property.properties.can_be_dormant.state.node;
				const raw_data: Record<string, any> = {};
				raw_can_be_dormant = raw_data
				break;
			}
			case 'yes': {
				const $_yes__can_be_dormant = $_ui_collection_property.properties.can_be_dormant.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expression"] = serialize_node_path_tail($_yes__can_be_dormant.properties.expression);
				raw_can_be_dormant = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.can_be_dormant.state)
		}
		raw_data["can be dormant"] = [$_ui_collection_property.properties.can_be_dormant.state.name, raw_can_be_dormant];
	}
	raw_data["classification"] = serialize_ui_property_classification($_ui_collection_property.properties.classification);
	{
		let raw_default_: Record<string, any>;
		switch ($_ui_collection_property.properties.default_.state.name) {
			case 'no': {
				const $_no__default__ui_collection_property = $_ui_collection_property.properties.default_.state.node;
				const raw_data: Record<string, any> = {};
				raw_default_ = raw_data
				break;
			}
			case 'yes': {
				const $_yes__default__ui_collection_property = $_ui_collection_property.properties.default_.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["entry filter"] = serialize_node_path_tail($_yes__default__ui_collection_property.properties.entry_filter);
				raw_data["key reference"] = serialize_entry_reference_selector($_yes__default__ui_collection_property.properties.key_reference);
				raw_default_ = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.default_.state)
		}
		raw_data["default"] = [$_ui_collection_property.properties.default_.state.name, raw_default_];
	}
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_collection_property.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_collection_property = $_ui_collection_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_collection_property = $_ui_collection_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_collection_property.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_collection_property.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_has_style: Record<string, any>;
		switch ($_ui_collection_property.properties.has_style.state.name) {
			case 'no': {
				const $_no__has_style__ui_collection_property = $_ui_collection_property.properties.has_style.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_style = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_style__ui_collection_property = $_ui_collection_property.properties.has_style.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["style expression"] = serialize_ui_expression($_yes__has_style__ui_collection_property.properties.style_expression);
				raw_has_style = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.has_style.state)
		}
		raw_data["has style"] = [$_ui_collection_property.properties.has_style.state.name, raw_has_style];
	}
	{
		let raw_icon: Record<string, any>;
		switch ($_ui_collection_property.properties.icon.state.name) {
			case 'no': {
				const $_no__icon__ui_collection_property = $_ui_collection_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_icon = raw_data
				break;
			}
			case 'yes': {
				const $_yes__icon__ui_collection_property = $_ui_collection_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_yes__icon__ui_collection_property.properties.name;
				raw_icon = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.icon.state)
		}
		raw_data["icon"] = [$_ui_collection_property.properties.icon.state.name, raw_icon];
	}
	{
		let raw_size: Record<string, any>;
		switch ($_ui_collection_property.properties.size.state.name) {
			case 'large': {
				const $_large = $_ui_collection_property.properties.size.state.node;
				const raw_data: Record<string, any> = {};
				raw_size = raw_data
				break;
			}
			case 'small': {
				const $_small = $_ui_collection_property.properties.size.state.node;
				const raw_data: Record<string, any> = {};
				raw_size = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.size.state)
		}
		raw_data["size"] = [$_ui_collection_property.properties.size.state.name, raw_size];
	}
	{
		let raw_sort: Record<string, any>;
		switch ($_ui_collection_property.properties.sort.state.name) {
			case 'no': {
				const $_no__sort = $_ui_collection_property.properties.sort.state.node;
				const raw_data: Record<string, any> = {};
				raw_sort = raw_data
				break;
			}
			case 'yes': {
				const $_yes__sort = $_ui_collection_property.properties.sort.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_direction: Record<string, any>;
					switch ($_yes__sort.properties.direction.state.name) {
						case 'ascending': {
							const $_ascending = $_yes__sort.properties.direction.state.node;
							const raw_data: Record<string, any> = {};
							raw_direction = raw_data
							break;
						}
						case 'descending': {
							const $_descending = $_yes__sort.properties.direction.state.node;
							const raw_data: Record<string, any> = {};
							raw_direction = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__sort.properties.direction.state)
					}
					raw_data["direction"] = [$_yes__sort.properties.direction.state.name, raw_direction];
				}
				raw_data["path"] = serialize_ui_node_path($_yes__sort.properties.path);
				raw_data["property"] = $_yes__sort.properties.property.entry;
				raw_sort = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_collection_property.properties.sort.state)
		}
		raw_data["sort"] = [$_ui_collection_property.properties.sort.state.name, raw_sort];
	}
	return raw_data;
}
function serialize_ui_command_attribute($_ui_command_attribute: read_api.Cui_command_attribute) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_command_attribute.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_command_attribute = $_ui_command_attribute.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_command_attribute = $_ui_command_attribute.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_command_attribute.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_command_attribute.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_command_attribute.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_visible: Record<string, any>;
		switch ($_ui_command_attribute.properties.visible.state.name) {
			case 'false': {
				const $_false__visible__ui_command_attribute = $_ui_command_attribute.properties.visible.state.node;
				const raw_data: Record<string, any> = {};
				raw_visible = raw_data
				break;
			}
			case 'true': {
				const $_true__visible__ui_command_attribute = $_ui_command_attribute.properties.visible.state.node;
				const raw_data: Record<string, any> = {};
				raw_visible = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_command_attribute.properties.visible.state)
		}
		raw_data["visible"] = [$_ui_command_attribute.properties.visible.state.name, raw_visible];
	}
	return raw_data;
}
function serialize_ui_entry_expression_list($_ui_entry_expression_list: read_api.Cui_entry_expression_list) {
	const raw_data: Record<string, any> = {};
	raw_data["entry expression"] = serialize_ui_expression($_ui_entry_expression_list.properties.entry_expression);
	{
		let raw_more_entries: Record<string, any>;
		switch ($_ui_entry_expression_list.properties.more_entries.state.name) {
			case 'no': {
				const $_no__more_entries = $_ui_entry_expression_list.properties.more_entries.state.node;
				const raw_data: Record<string, any> = {};
				raw_more_entries = raw_data
				break;
			}
			case 'yes': {
				const $_yes__more_entries = $_ui_entry_expression_list.properties.more_entries.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_ui_entry_expression_list($_yes__more_entries.properties.tail);
				raw_more_entries = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_entry_expression_list.properties.more_entries.state)
		}
		raw_data["more entries"] = [$_ui_entry_expression_list.properties.more_entries.state.name, raw_more_entries];
	}
	return raw_data;
}
function serialize_ui_expression($_ui_expression: read_api.Cui_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_operation: Record<string, any>;
		switch ($_ui_expression.properties.operation.state.name) {
			case 'entry': {
				const $_entry__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_entry__operation__ui_expression.properties.type.state.name) {
						case 'create': {
							const $_create__type__entry__operation__ui_expression = $_entry__operation__ui_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_object_expression($_create__type__entry__operation__ui_expression.properties.expression);
							raw_data["interaction"] = serialize_ui_action_interaction($_create__type__entry__operation__ui_expression.properties.interaction);
							raw_data["visualization"] = serialize_ui_action_visualization($_create__type__entry__operation__ui_expression.properties.visualization);
							raw_type = raw_data
							break;
						}
						case 'delete': {
							const $_delete__type__entry__operation__ui_expression = $_entry__operation__ui_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["interaction"] = serialize_ui_action_interaction($_delete__type__entry__operation__ui_expression.properties.interaction);
							raw_data["path"] = serialize_singular_node_path($_delete__type__entry__operation__ui_expression.properties.path);
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_entry__operation__ui_expression.properties.type.state)
					}
					raw_data["type"] = [$_entry__operation__ui_expression.properties.type.state.name, raw_type];
				}
				raw_operation = raw_data
				break;
			}
			case 'entry list': {
				const $_entry_list = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["entries"] = serialize_ui_entry_expression_list($_entry_list.properties.entries);
				raw_operation = raw_data
				break;
			}
			case 'execute operation': {
				const $_execute_operation__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expression"] = serialize_ui_object_expression($_execute_operation__operation__ui_expression.properties.expression);
				raw_data["interaction"] = serialize_ui_action_interaction($_execute_operation__operation__ui_expression.properties.interaction);
				raw_data["operation"] = $_execute_operation__operation__ui_expression.properties.operation.entry;
				raw_data["path"] = serialize_singular_node_path($_execute_operation__operation__ui_expression.properties.path);
				raw_operation = raw_data
				break;
			}
			case 'ignore': {
				const $_ignore__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_operation = raw_data
				break;
			}
			case 'node switch': {
				const $_node_switch__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				let raw_cases: Record<string, any>;
				{
					const $_cases__node_switch__operation__ui_expression = $_node_switch__operation__ui_expression.properties.cases;
					const raw_data: Record<string, any> = {};
					let raw_node_case: Record<string, any>;
					{
						const $_node_case__cases__node_switch__operation__ui_expression = $_cases__node_switch__operation__ui_expression.properties.node_case;
						const raw_data: Record<string, any> = {};
						raw_data["expression"] = serialize_ui_expression($_node_case__cases__node_switch__operation__ui_expression.properties.expression);
						raw_data["variable assignment"] = serialize_optional_variable_assignment($_node_case__cases__node_switch__operation__ui_expression.properties.variable_assignment);
						raw_node_case = raw_data
					}
					raw_data["node case"] = raw_node_case;
					let raw_none_case: Record<string, any>;
					{
						const $_none_case__cases__node_switch__operation__ui_expression = $_cases__node_switch__operation__ui_expression.properties.none_case;
						const raw_data: Record<string, any> = {};
						raw_data["expression"] = serialize_ui_expression($_none_case__cases__node_switch__operation__ui_expression.properties.expression);
						raw_none_case = raw_data
					}
					raw_data["none case"] = raw_none_case;
					raw_cases = raw_data
				}
				raw_data["cases"] = raw_cases;
				raw_data["expression"] = serialize_node_expression($_node_switch__operation__ui_expression.properties.expression);
				raw_operation = raw_data
				break;
			}
			case 'produce value': {
				const $_produce_value__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_value: Record<string, any>;
					switch ($_produce_value__operation__ui_expression.properties.value.state.name) {
						case 'object': {
							const $_object__value__produce_value__operation__ui_expression = $_produce_value__operation__ui_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_object_expression($_object__value__produce_value__operation__ui_expression.properties.expression);
							raw_value = raw_data
							break;
						}
						case 'scalar': {
							const $_scalar__value__produce_value__operation__ui_expression = $_produce_value__operation__ui_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_scalar_value_expression($_scalar__value__produce_value__operation__ui_expression.properties.expression);
							raw_value = raw_data
							break;
						}
						case 'state': {
							const $_state__value__produce_value__operation__ui_expression = $_produce_value__operation__ui_expression.properties.value.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_object_expression($_state__value__produce_value__operation__ui_expression.properties.expression);
							raw_data["state"] = $_state__value__produce_value__operation__ui_expression.properties.state.entry;
							raw_value = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_produce_value__operation__ui_expression.properties.value.state)
					}
					raw_data["value"] = [$_produce_value__operation__ui_expression.properties.value.state.name, raw_value];
				}
				raw_operation = raw_data
				break;
			}
			case 'state switch': {
				const $_state_switch__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				let raw_path: Record<string, any>;
				{
					const $_path__state_switch__operation__ui_expression = $_state_switch__operation__ui_expression.properties.path;
					const raw_data: Record<string, any> = {};
					raw_data["path"] = serialize_ui_parametrized_node_path($_path__state_switch__operation__ui_expression.properties.path);
					raw_data["stategroup"] = $_path__state_switch__operation__ui_expression.properties.stategroup.entry;
					raw_path = raw_data
				}
				raw_data["path"] = raw_path;
				const raw_states: Record<string, any> = {};
				for (let [k,v] of $_state_switch__operation__ui_expression.properties.states) {
					const $_states__state_switch__operation__ui_expression = v;
					const raw_data: Record<string, any> = {};
					raw_data["expression"] = serialize_ui_expression($_states__state_switch__operation__ui_expression.properties.expression);
					raw_data["variable assignment"] = serialize_optional_variable_assignment($_states__state_switch__operation__ui_expression.properties.variable_assignment);
					raw_states[k] = raw_data
				}
				raw_data["states"] = raw_states;
				raw_operation = raw_data
				break;
			}
			case 'update properties': {
				const $_update_properties__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["interaction"] = serialize_ui_action_interaction($_update_properties__operation__ui_expression.properties.interaction);
				raw_data["path"] = serialize_singular_node_path($_update_properties__operation__ui_expression.properties.path);
				{
					let raw_target: Record<string, any>;
					switch ($_update_properties__operation__ui_expression.properties.target.state.name) {
						case 'node': {
							const $_node__target__update_properties__operation__ui_expression = $_update_properties__operation__ui_expression.properties.target.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_object_expression($_node__target__update_properties__operation__ui_expression.properties.expression);
							raw_target = raw_data
							break;
						}
						case 'property': {
							const $_property__target__update_properties__operation__ui_expression = $_update_properties__operation__ui_expression.properties.target.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_expression($_property__target__update_properties__operation__ui_expression.properties.expression);
							raw_data["property"] = $_property__target__update_properties__operation__ui_expression.properties.property.entry;
							raw_target = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_update_properties__operation__ui_expression.properties.target.state)
					}
					raw_data["target"] = [$_update_properties__operation__ui_expression.properties.target.state.name, raw_target];
				}
				raw_data["visualization"] = serialize_ui_action_visualization($_update_properties__operation__ui_expression.properties.visualization);
				raw_operation = raw_data
				break;
			}
			case 'walk': {
				const $_walk__operation__ui_expression = $_ui_expression.properties.operation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["collection"] = $_walk__operation__ui_expression.properties.collection.entry;
				raw_data["expression"] = serialize_ui_expression($_walk__operation__ui_expression.properties.expression);
				raw_data["path"] = serialize_singular_node_path($_walk__operation__ui_expression.properties.path);
				raw_data["tail"] = serialize_node_path_tail($_walk__operation__ui_expression.properties.tail);
				raw_data["variable assignment"] = serialize_optional_variable_assignment($_walk__operation__ui_expression.properties.variable_assignment);
				raw_operation = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_expression.properties.operation.state)
		}
		raw_data["operation"] = [$_ui_expression.properties.operation.state.name, raw_operation];
	}
	return raw_data;
}
function serialize_ui_file_property($_ui_file_property: read_api.Cui_file_property) {
	const raw_data: Record<string, any> = {};
	raw_data["classification"] = serialize_ui_property_classification($_ui_file_property.properties.classification);
	{
		let raw_file_name_expression: Record<string, any>;
		switch ($_ui_file_property.properties.file_name_expression.state.name) {
			case 'no': {
				const $_no__file_name_expression = $_ui_file_property.properties.file_name_expression.state.node;
				const raw_data: Record<string, any> = {};
				raw_file_name_expression = raw_data
				break;
			}
			case 'yes': {
				const $_yes__file_name_expression = $_ui_file_property.properties.file_name_expression.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["file name expression"] = serialize_ui_scalar_default($_yes__file_name_expression.properties.file_name_expression);
				raw_file_name_expression = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_file_property.properties.file_name_expression.state)
		}
		raw_data["file name expression"] = [$_ui_file_property.properties.file_name_expression.state.name, raw_file_name_expression];
	}
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_file_property.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_file_property = $_ui_file_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_file_property = $_ui_file_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_file_property.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_file_property.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_file_property.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_icon: Record<string, any>;
		switch ($_ui_file_property.properties.icon.state.name) {
			case 'no': {
				const $_no__icon__ui_file_property = $_ui_file_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_icon = raw_data
				break;
			}
			case 'yes': {
				const $_yes__icon__ui_file_property = $_ui_file_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_yes__icon__ui_file_property.properties.name;
				raw_icon = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_file_property.properties.icon.state)
		}
		raw_data["icon"] = [$_ui_file_property.properties.icon.state.name, raw_icon];
	}
	return raw_data;
}
function serialize_ui_group_property($_ui_group_property: read_api.Cui_group_property) {
	const raw_data: Record<string, any> = {};
	{
		let raw_break_out: Record<string, any>;
		switch ($_ui_group_property.properties.break_out.state.name) {
			case 'no': {
				const $_no__break_out__ui_group_property = $_ui_group_property.properties.break_out.state.node;
				const raw_data: Record<string, any> = {};
				raw_break_out = raw_data
				break;
			}
			case 'yes': {
				const $_yes__break_out__ui_group_property = $_ui_group_property.properties.break_out.state.node;
				const raw_data: Record<string, any> = {};
				raw_break_out = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_group_property.properties.break_out.state)
		}
		raw_data["break out"] = [$_ui_group_property.properties.break_out.state.name, raw_break_out];
	}
	raw_data["classification"] = serialize_ui_property_classification($_ui_group_property.properties.classification);
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_group_property.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_group_property = $_ui_group_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_group_property = $_ui_group_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_group_property.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_group_property.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_group_property.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_icon: Record<string, any>;
		switch ($_ui_group_property.properties.icon.state.name) {
			case 'no': {
				const $_no__icon__ui_group_property = $_ui_group_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_icon = raw_data
				break;
			}
			case 'yes': {
				const $_yes__icon__ui_group_property = $_ui_group_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_yes__icon__ui_group_property.properties.name;
				raw_icon = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_group_property.properties.icon.state)
		}
		raw_data["icon"] = [$_ui_group_property.properties.icon.state.name, raw_icon];
	}
	return raw_data;
}
function serialize_ui_identifying_property_selection($_ui_identifying_property_selection: read_api.Cui_identifying_property_selection) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_properties: Record<string, any>;
		switch ($_ui_identifying_property_selection.properties.has_properties.state.name) {
			case 'no': {
				const $_no__has_properties = $_ui_identifying_property_selection.properties.has_properties.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_properties = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_properties = $_ui_identifying_property_selection.properties.has_properties.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["first"] = $_yes__has_properties.properties.first.entry;
				raw_has_properties = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_identifying_property_selection.properties.has_properties.state)
		}
		raw_data["has properties"] = [$_ui_identifying_property_selection.properties.has_properties.state.name, raw_has_properties];
	}
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_ui_identifying_property_selection.properties.properties) {
		const $_properties__ui_identifying_property_selection = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_has_successor: Record<string, any>;
			switch ($_properties__ui_identifying_property_selection.properties.has_successor.state.name) {
				case 'no': {
					const $_no__has_successor__properties = $_properties__ui_identifying_property_selection.properties.has_successor.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_successor = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_successor__properties = $_properties__ui_identifying_property_selection.properties.has_successor.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["successor"] = $_yes__has_successor__properties.properties.successor.entry;
					raw_has_successor = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_properties__ui_identifying_property_selection.properties.has_successor.state)
			}
			raw_data["has successor"] = [$_properties__ui_identifying_property_selection.properties.has_successor.state.name, raw_has_successor];
		}
		{
			let raw_value_type: Record<string, any>;
			switch ($_properties__ui_identifying_property_selection.properties.value_type.state.name) {
				case 'choice': {
					const $_choice__value_type__properties = $_properties__ui_identifying_property_selection.properties.value_type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["first state"] = $_choice__value_type__properties.properties.first_state.entry;
					{
						let raw_state_key_is_identifying: Record<string, any>;
						switch ($_choice__value_type__properties.properties.state_key_is_identifying.state.name) {
							case 'no': {
								const $_no__state_key_is_identifying = $_choice__value_type__properties.properties.state_key_is_identifying.state.node;
								const raw_data: Record<string, any> = {};
								raw_state_key_is_identifying = raw_data
								break;
							}
							case 'yes': {
								const $_yes__state_key_is_identifying = $_choice__value_type__properties.properties.state_key_is_identifying.state.node;
								const raw_data: Record<string, any> = {};
								raw_state_key_is_identifying = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_choice__value_type__properties.properties.state_key_is_identifying.state)
						}
						raw_data["state key is identifying"] = [$_choice__value_type__properties.properties.state_key_is_identifying.state.name, raw_state_key_is_identifying];
					}
					const raw_states: Record<string, any> = {};
					for (let [k,v] of $_choice__value_type__properties.properties.states) {
						const $_states__choice = v;
						const raw_data: Record<string, any> = {};
						{
							let raw_has_successor: Record<string, any>;
							switch ($_states__choice.properties.has_successor.state.name) {
								case 'no': {
									const $_no__has_successor__states__choice = $_states__choice.properties.has_successor.state.node;
									const raw_data: Record<string, any> = {};
									raw_has_successor = raw_data
									break;
								}
								case 'yes': {
									const $_yes__has_successor__states__choice = $_states__choice.properties.has_successor.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["successor"] = $_yes__has_successor__states__choice.properties.successor.entry;
									raw_has_successor = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_states__choice.properties.has_successor.state)
							}
							raw_data["has successor"] = [$_states__choice.properties.has_successor.state.name, raw_has_successor];
						}
						raw_data["selection"] = serialize_ui_identifying_property_selection($_states__choice.properties.selection);
						raw_states[k] = raw_data
					}
					raw_data["states"] = raw_states;
					raw_value_type = raw_data
					break;
				}
				case 'node': {
					const $_node__value_type__properties = $_properties__ui_identifying_property_selection.properties.value_type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["selection"] = serialize_ui_identifying_property_selection($_node__value_type__properties.properties.selection);
					raw_value_type = raw_data
					break;
				}
				case 'scalar': {
					const $_scalar__value_type = $_properties__ui_identifying_property_selection.properties.value_type.state.node;
					const raw_data: Record<string, any> = {};
					raw_value_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_properties__ui_identifying_property_selection.properties.value_type.state)
			}
			raw_data["value type"] = [$_properties__ui_identifying_property_selection.properties.value_type.state.name, raw_value_type];
		}
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_ui_node_path($_ui_node_path: read_api.Cui_node_path) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_node_path($_ui_node_path.properties.path);
	return raw_data;
}
function serialize_ui_number_property($_ui_number_property: read_api.Cui_number_property) {
	const raw_data: Record<string, any> = {};
	raw_data["classification"] = serialize_ui_property_classification($_ui_number_property.properties.classification);
	{
		let raw_default_: Record<string, any>;
		switch ($_ui_number_property.properties.default_.state.name) {
			case 'no': {
				const $_no__default__ui_number_property = $_ui_number_property.properties.default_.state.node;
				const raw_data: Record<string, any> = {};
				raw_default_ = raw_data
				break;
			}
			case 'yes': {
				const $_yes__default__ui_number_property = $_ui_number_property.properties.default_.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["default"] = serialize_ui_scalar_default($_yes__default__ui_number_property.properties.default_);
				raw_default_ = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_number_property.properties.default_.state)
		}
		raw_data["default"] = [$_ui_number_property.properties.default_.state.name, raw_default_];
	}
	{
		let raw_dynamic_numerical_type: Record<string, any>;
		switch ($_ui_number_property.properties.dynamic_numerical_type.state.name) {
			case 'no': {
				const $_no__dynamic_numerical_type = $_ui_number_property.properties.dynamic_numerical_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_dynamic_numerical_type = raw_data
				break;
			}
			case 'yes': {
				const $_yes__dynamic_numerical_type = $_ui_number_property.properties.dynamic_numerical_type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["binding path"] = serialize_node_path($_yes__dynamic_numerical_type.properties.binding_path);
				raw_dynamic_numerical_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_number_property.properties.dynamic_numerical_type.state)
		}
		raw_data["dynamic numerical type"] = [$_ui_number_property.properties.dynamic_numerical_type.state.name, raw_dynamic_numerical_type];
	}
	{
		let raw_emphasis: Record<string, any>;
		switch ($_ui_number_property.properties.emphasis.state.name) {
			case 'no': {
				const $_no__emphasis__ui_number_property = $_ui_number_property.properties.emphasis.state.node;
				const raw_data: Record<string, any> = {};
				raw_emphasis = raw_data
				break;
			}
			case 'yes': {
				const $_yes__emphasis__ui_number_property = $_ui_number_property.properties.emphasis.state.node;
				const raw_data: Record<string, any> = {};
				raw_emphasis = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_number_property.properties.emphasis.state)
		}
		raw_data["emphasis"] = [$_ui_number_property.properties.emphasis.state.name, raw_emphasis];
	}
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_number_property.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_number_property = $_ui_number_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_number_property = $_ui_number_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_number_property.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_number_property.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_number_property.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_icon: Record<string, any>;
		switch ($_ui_number_property.properties.icon.state.name) {
			case 'no': {
				const $_no__icon__ui_number_property = $_ui_number_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_icon = raw_data
				break;
			}
			case 'yes': {
				const $_yes__icon__ui_number_property = $_ui_number_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_yes__icon__ui_number_property.properties.name;
				raw_icon = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_number_property.properties.icon.state)
		}
		raw_data["icon"] = [$_ui_number_property.properties.icon.state.name, raw_icon];
	}
	{
		let raw_metadata: Record<string, any>;
		switch ($_ui_number_property.properties.metadata.state.name) {
			case 'no': {
				const $_no__metadata = $_ui_number_property.properties.metadata.state.node;
				const raw_data: Record<string, any> = {};
				raw_metadata = raw_data
				break;
			}
			case 'yes': {
				const $_yes__metadata = $_ui_number_property.properties.metadata.state.node;
				const raw_data: Record<string, any> = {};
				raw_metadata = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_number_property.properties.metadata.state)
		}
		raw_data["metadata"] = [$_ui_number_property.properties.metadata.state.name, raw_metadata];
	}
	let raw_validation: Record<string, any>;
	{
		const $_validation = $_ui_number_property.properties.validation;
		const raw_data: Record<string, any> = {};
		{
			let raw_has_maximum: Record<string, any>;
			switch ($_validation.properties.has_maximum.state.name) {
				case 'no': {
					const $_no__has_maximum = $_validation.properties.has_maximum.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_maximum = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_maximum = $_validation.properties.has_maximum.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["maximum"] = serialize_ui_expression($_yes__has_maximum.properties.maximum);
					raw_has_maximum = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_validation.properties.has_maximum.state)
			}
			raw_data["has maximum"] = [$_validation.properties.has_maximum.state.name, raw_has_maximum];
		}
		{
			let raw_has_minimum: Record<string, any>;
			switch ($_validation.properties.has_minimum.state.name) {
				case 'no': {
					const $_no__has_minimum = $_validation.properties.has_minimum.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_minimum = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_minimum = $_validation.properties.has_minimum.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["minimum"] = serialize_ui_expression($_yes__has_minimum.properties.minimum);
					raw_has_minimum = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_validation.properties.has_minimum.state)
			}
			raw_data["has minimum"] = [$_validation.properties.has_minimum.state.name, raw_has_minimum];
		}
		raw_validation = raw_data
	}
	raw_data["validation"] = raw_validation;
	return raw_data;
}
function serialize_ui_numerical_type($_ui_numerical_type: read_api.Cui_numerical_type) {
	const raw_data: Record<string, any> = {};
	{
		let raw_represent_as: Record<string, any>;
		switch ($_ui_numerical_type.properties.represent_as.state.name) {
			case 'custom type': {
				const $_custom_type = $_ui_numerical_type.properties.represent_as.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_binding: Record<string, any>;
					switch ($_custom_type.properties.binding.state.name) {
						case 'dynamic': {
							const $_dynamic__binding = $_custom_type.properties.binding.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["assignment"] = serialize_variable_assignment($_dynamic__binding.properties.assignment);
							raw_data["path"] = serialize_node_type_id($_dynamic__binding.properties.path);
							raw_binding = raw_data
							break;
						}
						case 'root': {
							const $_root = $_custom_type.properties.binding.state.node;
							const raw_data: Record<string, any> = {};
							raw_binding = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_custom_type.properties.binding.state)
					}
					raw_data["binding"] = [$_custom_type.properties.binding.state.name, raw_binding];
				}
				let raw_properties: Record<string, any>;
				{
					const $_properties__custom_type = $_custom_type.properties.properties;
					const raw_data: Record<string, any> = {};
					{
						let raw_conversion: Record<string, any>;
						switch ($_properties__custom_type.properties.conversion.state.name) {
							case 'none': {
								const $_none__conversion = $_properties__custom_type.properties.conversion.state.node;
								const raw_data: Record<string, any> = {};
								raw_conversion = raw_data
								break;
							}
							case 'point translation': {
								const $_point_translation = $_properties__custom_type.properties.conversion.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["decimals"] = serialize_ui_scalar_value_expression($_point_translation.properties.decimals);
								raw_conversion = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_properties__custom_type.properties.conversion.state)
						}
						raw_data["conversion"] = [$_properties__custom_type.properties.conversion.state.name, raw_conversion];
					}
					raw_data["label"] = serialize_ui_scalar_value_expression($_properties__custom_type.properties.label);
					raw_properties = raw_data
				}
				raw_data["properties"] = raw_properties;
				raw_represent_as = raw_data
				break;
			}
			case 'date': {
				const $_date = $_ui_numerical_type.properties.represent_as.state.node;
				const raw_data: Record<string, any> = {};
				raw_represent_as = raw_data
				break;
			}
			case 'date and time': {
				const $_date_and_time = $_ui_numerical_type.properties.represent_as.state.node;
				const raw_data: Record<string, any> = {};
				raw_represent_as = raw_data
				break;
			}
			case 'duration': {
				const $_duration = $_ui_numerical_type.properties.represent_as.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_unit: Record<string, any>;
					switch ($_duration.properties.unit.state.name) {
						case 'hours': {
							const $_hours = $_duration.properties.unit.state.node;
							const raw_data: Record<string, any> = {};
							raw_unit = raw_data
							break;
						}
						case 'minutes': {
							const $_minutes = $_duration.properties.unit.state.node;
							const raw_data: Record<string, any> = {};
							raw_unit = raw_data
							break;
						}
						case 'seconds': {
							const $_seconds__unit = $_duration.properties.unit.state.node;
							const raw_data: Record<string, any> = {};
							raw_unit = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_duration.properties.unit.state)
					}
					raw_data["unit"] = [$_duration.properties.unit.state.name, raw_unit];
				}
				raw_represent_as = raw_data
				break;
			}
			case 'model': {
				const $_model = $_ui_numerical_type.properties.represent_as.state.node;
				const raw_data: Record<string, any> = {};
				raw_represent_as = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_numerical_type.properties.represent_as.state)
		}
		raw_data["represent as"] = [$_ui_numerical_type.properties.represent_as.state.name, raw_represent_as];
	}
	return raw_data;
}
function serialize_ui_object_expression($_ui_object_expression: read_api.Cui_object_expression) {
	const raw_data: Record<string, any> = {};
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_ui_object_expression.properties.properties) {
		const $_properties__ui_object_expression = v;
		const raw_data: Record<string, any> = {};
		raw_data["default"] = serialize_ui_expression($_properties__ui_object_expression.properties.default_);
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_ui_parametrized_node_path($_ui_parametrized_node_path: read_api.Cui_parametrized_node_path) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_conditional_node_path($_ui_parametrized_node_path.properties.path);
	return raw_data;
}
function serialize_ui_property_classification($_ui_property_classification: read_api.Cui_property_classification) {
	const raw_data: Record<string, any> = {};
	{
		let raw_classification: Record<string, any>;
		switch ($_ui_property_classification.properties.classification.state.name) {
			case 'hidden': {
				const $_hidden = $_ui_property_classification.properties.classification.state.node;
				const raw_data: Record<string, any> = {};
				raw_classification = raw_data
				break;
			}
			case 'identifying': {
				const $_identifying = $_ui_property_classification.properties.classification.state.node;
				const raw_data: Record<string, any> = {};
				raw_classification = raw_data
				break;
			}
			case 'outlining': {
				const $_outlining = $_ui_property_classification.properties.classification.state.node;
				const raw_data: Record<string, any> = {};
				raw_classification = raw_data
				break;
			}
			case 'standard': {
				const $_standard = $_ui_property_classification.properties.classification.state.node;
				const raw_data: Record<string, any> = {};
				raw_classification = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_property_classification.properties.classification.state)
		}
		raw_data["classification"] = [$_ui_property_classification.properties.classification.state.name, raw_classification];
	}
	return raw_data;
}
function serialize_ui_reference_rule($_ui_reference_rule: read_api.Cui_reference_rule) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_validation: Record<string, any>;
		switch ($_ui_reference_rule.properties.has_validation.state.name) {
			case 'no': {
				const $_no__has_validation__ui_reference_rule = $_ui_reference_rule.properties.has_validation.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_validation = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_validation__ui_reference_rule = $_ui_reference_rule.properties.has_validation.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_validation = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_reference_rule.properties.has_validation.state)
		}
		raw_data["has validation"] = [$_ui_reference_rule.properties.has_validation.state.name, raw_has_validation];
	}
	return raw_data;
}
function serialize_ui_reference_set_attribute($_ui_reference_set_attribute: read_api.Cui_reference_set_attribute) {
	const raw_data: Record<string, any> = {};
	{
		let raw_break_out: Record<string, any>;
		switch ($_ui_reference_set_attribute.properties.break_out.state.name) {
			case 'no': {
				const $_no__break_out__ui_reference_set_attribute = $_ui_reference_set_attribute.properties.break_out.state.node;
				const raw_data: Record<string, any> = {};
				raw_break_out = raw_data
				break;
			}
			case 'yes': {
				const $_yes__break_out__ui_reference_set_attribute = $_ui_reference_set_attribute.properties.break_out.state.node;
				const raw_data: Record<string, any> = {};
				raw_break_out = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_reference_set_attribute.properties.break_out.state)
		}
		raw_data["break out"] = [$_ui_reference_set_attribute.properties.break_out.state.name, raw_break_out];
	}
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_reference_set_attribute.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_reference_set_attribute = $_ui_reference_set_attribute.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_reference_set_attribute = $_ui_reference_set_attribute.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_reference_set_attribute.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_reference_set_attribute.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_reference_set_attribute.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_visible: Record<string, any>;
		switch ($_ui_reference_set_attribute.properties.visible.state.name) {
			case 'false': {
				const $_false__visible__ui_reference_set_attribute = $_ui_reference_set_attribute.properties.visible.state.node;
				const raw_data: Record<string, any> = {};
				raw_visible = raw_data
				break;
			}
			case 'true': {
				const $_true__visible__ui_reference_set_attribute = $_ui_reference_set_attribute.properties.visible.state.node;
				const raw_data: Record<string, any> = {};
				raw_visible = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_reference_set_attribute.properties.visible.state)
		}
		raw_data["visible"] = [$_ui_reference_set_attribute.properties.visible.state.name, raw_visible];
	}
	return raw_data;
}
function serialize_ui_scalar_default($_ui_scalar_default: read_api.Cui_scalar_default) {
	const raw_data: Record<string, any> = {};
	raw_data["expression"] = serialize_ui_expression($_ui_scalar_default.properties.expression);
	{
		let raw_has_fallback: Record<string, any>;
		switch ($_ui_scalar_default.properties.has_fallback.state.name) {
			case 'no': {
				const $_no__has_fallback = $_ui_scalar_default.properties.has_fallback.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_fallback = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_fallback = $_ui_scalar_default.properties.has_fallback.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["fallback"] = serialize_ui_scalar_default($_yes__has_fallback.properties.fallback);
				raw_has_fallback = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_scalar_default.properties.has_fallback.state)
		}
		raw_data["has fallback"] = [$_ui_scalar_default.properties.has_fallback.state.name, raw_has_fallback];
	}
	return raw_data;
}
function serialize_ui_scalar_value_expression($_ui_scalar_value_expression: read_api.Cui_scalar_value_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_ui_scalar_value_expression.properties.type.state.name) {
			case 'dynamic': {
				const $_dynamic__type__ui_scalar_value_expression = $_ui_scalar_value_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["path"] = serialize_ui_parametrized_node_path($_dynamic__type__ui_scalar_value_expression.properties.path);
				raw_data["property"] = $_dynamic__type__ui_scalar_value_expression.properties.property.entry;
				raw_type = raw_data
				break;
			}
			case 'number': {
				const $_number__type__ui_scalar_value_expression = $_ui_scalar_value_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_number__type__ui_scalar_value_expression.properties.type.state.name) {
						case 'binary expression': {
							const $_binary_expression__type__number__type__ui_scalar_value_expression = $_number__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							let raw_expressions: Record<string, any>;
							{
								const $_expressions__binary_expression__type__number__type__ui_scalar_value_expression = $_binary_expression__type__number__type__ui_scalar_value_expression.properties.expressions;
								const raw_data: Record<string, any> = {};
								raw_data["left"] = serialize_ui_scalar_value_expression($_expressions__binary_expression__type__number__type__ui_scalar_value_expression.properties.left);
								raw_data["right"] = serialize_ui_scalar_value_expression($_expressions__binary_expression__type__number__type__ui_scalar_value_expression.properties.right);
								raw_expressions = raw_data
							}
							raw_data["expressions"] = raw_expressions;
							{
								let raw_operation: Record<string, any>;
								switch ($_binary_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.name) {
									case 'division': {
										const $_division__operation__binary_expression__type__number__type__ui_scalar_value_expression = $_binary_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										{
											let raw_rounding: Record<string, any>;
											switch ($_division__operation__binary_expression__type__number__type__ui_scalar_value_expression.properties.rounding.state.name) {
												case 'ceil': {
													const $_ceil__rounding__division__operation__binary_expression__type__number__type__ui_scalar_value_expression = $_division__operation__binary_expression__type__number__type__ui_scalar_value_expression.properties.rounding.state.node;
													const raw_data: Record<string, any> = {};
													raw_rounding = raw_data
													break;
												}
												case 'floor': {
													const $_floor__rounding__division__operation__binary_expression__type__number__type__ui_scalar_value_expression = $_division__operation__binary_expression__type__number__type__ui_scalar_value_expression.properties.rounding.state.node;
													const raw_data: Record<string, any> = {};
													raw_rounding = raw_data
													break;
												}
												case 'ordinary': {
													const $_ordinary__rounding__division__operation__binary_expression__type__number__type__ui_scalar_value_expression = $_division__operation__binary_expression__type__number__type__ui_scalar_value_expression.properties.rounding.state.node;
													const raw_data: Record<string, any> = {};
													raw_rounding = raw_data
													break;
												}
												default:
													throw new Error("unexpected state: " + $_division__operation__binary_expression__type__number__type__ui_scalar_value_expression.properties.rounding.state)
											}
											raw_data["rounding"] = [$_division__operation__binary_expression__type__number__type__ui_scalar_value_expression.properties.rounding.state.name, raw_rounding];
										}
										raw_operation = raw_data
										break;
									}
									case 'remainder': {
										const $_remainder__operation__binary_expression__type__number__type__ui_scalar_value_expression = $_binary_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_binary_expression__type__number__type__ui_scalar_value_expression.properties.operation.state)
								}
								raw_data["operation"] = [$_binary_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.name, raw_operation];
							}
							raw_type = raw_data
							break;
						}
						case 'constant': {
							const $_constant__type__number__type__ui_scalar_value_expression = $_number__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["value"] = serialize_constant_number_value($_constant__type__number__type__ui_scalar_value_expression.properties.value);
							raw_type = raw_data
							break;
						}
						case 'list expression': {
							const $_list_expression__type__number__type__ui_scalar_value_expression = $_number__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_operation: Record<string, any>;
								switch ($_list_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.name) {
									case 'maximum': {
										const $_maximum__operation__list_expression__type__number__type__ui_scalar_value_expression = $_list_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'minimum': {
										const $_minimum__operation__list_expression__type__number__type__ui_scalar_value_expression = $_list_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'product': {
										const $_product__operation__list_expression__type__number__type__ui_scalar_value_expression = $_list_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									case 'sum': {
										const $_sum__operation__list_expression__type__number__type__ui_scalar_value_expression = $_list_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.node;
										const raw_data: Record<string, any> = {};
										raw_operation = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_list_expression__type__number__type__ui_scalar_value_expression.properties.operation.state)
								}
								raw_data["operation"] = [$_list_expression__type__number__type__ui_scalar_value_expression.properties.operation.state.name, raw_operation];
							}
							raw_data["value"] = serialize_ui_scalar_value_expression_list($_list_expression__type__number__type__ui_scalar_value_expression.properties.value);
							raw_type = raw_data
							break;
						}
						case 'now in seconds': {
							const $_now_in_seconds__type__number__type__ui_scalar_value_expression = $_number__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'unary expression': {
							const $_unary_expression__type__number__type__ui_scalar_value_expression = $_number__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_scalar_value_expression($_unary_expression__type__number__type__ui_scalar_value_expression.properties.expression);
							{
								let raw_type: Record<string, any>;
								switch ($_unary_expression__type__number__type__ui_scalar_value_expression.properties.type.state.name) {
									case 'absolute value': {
										const $_absolute_value__type__unary_expression__type__number__type__ui_scalar_value_expression = $_unary_expression__type__number__type__ui_scalar_value_expression.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_type = raw_data
										break;
									}
									case 'numerical type conversion': {
										const $_numerical_type_conversion__type__unary_expression__type__number__type__ui_scalar_value_expression = $_unary_expression__type__number__type__ui_scalar_value_expression.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["conversion"] = $_numerical_type_conversion__type__unary_expression__type__number__type__ui_scalar_value_expression.properties.conversion.entry;
										{
											let raw_representation_based: Record<string, any>;
											switch ($_numerical_type_conversion__type__unary_expression__type__number__type__ui_scalar_value_expression.properties.representation_based.state.name) {
												case 'no': {
													const $_no__representation_based = $_numerical_type_conversion__type__unary_expression__type__number__type__ui_scalar_value_expression.properties.representation_based.state.node;
													const raw_data: Record<string, any> = {};
													raw_representation_based = raw_data
													break;
												}
												case 'ui date and time': {
													const $_ui_date_and_time = $_numerical_type_conversion__type__unary_expression__type__number__type__ui_scalar_value_expression.properties.representation_based.state.node;
													const raw_data: Record<string, any> = {};
													raw_representation_based = raw_data
													break;
												}
												default:
													throw new Error("unexpected state: " + $_numerical_type_conversion__type__unary_expression__type__number__type__ui_scalar_value_expression.properties.representation_based.state)
											}
											raw_data["representation based"] = [$_numerical_type_conversion__type__unary_expression__type__number__type__ui_scalar_value_expression.properties.representation_based.state.name, raw_representation_based];
										}
										raw_type = raw_data
										break;
									}
									case 'sign inversion': {
										const $_sign_inversion__type__unary_expression__type__number__type__ui_scalar_value_expression = $_unary_expression__type__number__type__ui_scalar_value_expression.properties.type.state.node;
										const raw_data: Record<string, any> = {};
										raw_type = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_unary_expression__type__number__type__ui_scalar_value_expression.properties.type.state)
								}
								raw_data["type"] = [$_unary_expression__type__number__type__ui_scalar_value_expression.properties.type.state.name, raw_type];
							}
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_number__type__ui_scalar_value_expression.properties.type.state)
					}
					raw_data["type"] = [$_number__type__ui_scalar_value_expression.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			case 'state': {
				const $_state__type__ui_scalar_value_expression = $_ui_scalar_value_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["state"] = $_state__type__ui_scalar_value_expression.properties.state.entry;
				raw_type = raw_data
				break;
			}
			case 'sticky': {
				const $_sticky = $_ui_scalar_value_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'style': {
				const $_style__type = $_ui_scalar_value_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_style__type.properties.type.state.name) {
						case 'fixed': {
							const $_fixed = $_style__type.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["style"] = serialize_ui_style($_fixed.properties.style);
							raw_type = raw_data
							break;
						}
						case 'property': {
							const $_property__type__style = $_style__type.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_scalar_value_expression($_property__type__style.properties.expression);
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_style__type.properties.type.state)
					}
					raw_data["type"] = [$_style__type.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			case 'text': {
				const $_text__type__ui_scalar_value_expression = $_ui_scalar_value_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_type: Record<string, any>;
					switch ($_text__type__ui_scalar_value_expression.properties.type.state.name) {
						case 'auto increment': {
							const $_auto_increment = $_text__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["scope"] = serialize_ancestor_node_path($_auto_increment.properties.scope);
							raw_type = raw_data
							break;
						}
						case 'concatenation': {
							const $_concatenation__type__text__type__ui_scalar_value_expression = $_text__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["list"] = serialize_ui_scalar_value_expression_list($_concatenation__type__text__type__ui_scalar_value_expression.properties.list);
							raw_type = raw_data
							break;
						}
						case 'guid': {
							const $_guid = $_text__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'number to text': {
							const $_number_to_text = $_text__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["expression"] = serialize_ui_scalar_value_expression($_number_to_text.properties.expression);
							raw_data["numerical type"] = $_number_to_text.properties.numerical_type.entry;
							{
								let raw_pad: Record<string, any>;
								switch ($_number_to_text.properties.pad.state.name) {
									case 'no': {
										const $_no__pad = $_number_to_text.properties.pad.state.node;
										const raw_data: Record<string, any> = {};
										raw_pad = raw_data
										break;
									}
									case 'yes': {
										const $_yes__pad = $_number_to_text.properties.pad.state.node;
										const raw_data: Record<string, any> = {};
										raw_data["character"] = $_yes__pad.properties.character;
										raw_data["size"] = $_yes__pad.properties.size.value;
										raw_pad = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_number_to_text.properties.pad.state)
								}
								raw_data["pad"] = [$_number_to_text.properties.pad.state.name, raw_pad];
							}
							raw_type = raw_data
							break;
						}
						case 'static': {
							const $_static__type__text__type__ui_scalar_value_expression = $_text__type__ui_scalar_value_expression.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["value"] = $_static__type__text__type__ui_scalar_value_expression.properties.value;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_text__type__ui_scalar_value_expression.properties.type.state)
					}
					raw_data["type"] = [$_text__type__ui_scalar_value_expression.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_scalar_value_expression.properties.type.state)
		}
		raw_data["type"] = [$_ui_scalar_value_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_ui_scalar_value_expression_list($_ui_scalar_value_expression_list: read_api.Cui_scalar_value_expression_list) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_tail: Record<string, any>;
		switch ($_ui_scalar_value_expression_list.properties.has_tail.state.name) {
			case 'no': {
				const $_no__has_tail__ui_scalar_value_expression_list = $_ui_scalar_value_expression_list.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_tail = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_tail__ui_scalar_value_expression_list = $_ui_scalar_value_expression_list.properties.has_tail.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_ui_scalar_value_expression_list($_yes__has_tail__ui_scalar_value_expression_list.properties.tail);
				raw_has_tail = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_scalar_value_expression_list.properties.has_tail.state)
		}
		raw_data["has tail"] = [$_ui_scalar_value_expression_list.properties.has_tail.state.name, raw_has_tail];
	}
	raw_data["value"] = serialize_ui_scalar_value_expression($_ui_scalar_value_expression_list.properties.value);
	return raw_data;
}
function serialize_ui_state($_ui_state: read_api.Cui_state) {
	const raw_data: Record<string, any> = {};
	{
		let raw_desired_state: Record<string, any>;
		switch ($_ui_state.properties.desired_state.state.name) {
			case 'no': {
				const $_no__desired_state = $_ui_state.properties.desired_state.state.node;
				const raw_data: Record<string, any> = {};
				raw_desired_state = raw_data
				break;
			}
			case 'yes': {
				const $_yes__desired_state = $_ui_state.properties.desired_state.state.node;
				const raw_data: Record<string, any> = {};
				raw_desired_state = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state.properties.desired_state.state)
		}
		raw_data["desired state"] = [$_ui_state.properties.desired_state.state.name, raw_desired_state];
	}
	{
		let raw_has_style: Record<string, any>;
		switch ($_ui_state.properties.has_style.state.name) {
			case 'no': {
				const $_no__has_style__ui_state = $_ui_state.properties.has_style.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_style = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_style__ui_state = $_ui_state.properties.has_style.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["style expression"] = serialize_ui_expression($_yes__has_style__ui_state.properties.style_expression);
				raw_has_style = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state.properties.has_style.state)
		}
		raw_data["has style"] = [$_ui_state.properties.has_style.state.name, raw_has_style];
	}
	{
		let raw_icon: Record<string, any>;
		switch ($_ui_state.properties.icon.state.name) {
			case 'no': {
				const $_no__icon__ui_state = $_ui_state.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_icon = raw_data
				break;
			}
			case 'yes': {
				const $_yes__icon__ui_state = $_ui_state.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_yes__icon__ui_state.properties.name;
				raw_icon = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state.properties.icon.state)
		}
		raw_data["icon"] = [$_ui_state.properties.icon.state.name, raw_icon];
	}
	const raw_transitions: Record<string, any> = {};
	for (let [k,v] of $_ui_state.properties.transitions) {
		const $_transitions = v;
		const raw_data: Record<string, any> = {};
		raw_data["action"] = $_transitions.properties.action.entry;
		raw_transitions[k] = raw_data
	}
	raw_data["transitions"] = raw_transitions;
	{
		let raw_verified_state: Record<string, any>;
		switch ($_ui_state.properties.verified_state.state.name) {
			case 'no': {
				const $_no__verified_state = $_ui_state.properties.verified_state.state.node;
				const raw_data: Record<string, any> = {};
				raw_verified_state = raw_data
				break;
			}
			case 'yes': {
				const $_yes__verified_state = $_ui_state.properties.verified_state.state.node;
				const raw_data: Record<string, any> = {};
				raw_verified_state = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state.properties.verified_state.state)
		}
		raw_data["verified state"] = [$_ui_state.properties.verified_state.state.name, raw_verified_state];
	}
	return raw_data;
}
function serialize_ui_state_group_property($_ui_state_group_property: read_api.Cui_state_group_property) {
	const raw_data: Record<string, any> = {};
	raw_data["classification"] = serialize_ui_property_classification($_ui_state_group_property.properties.classification);
	{
		let raw_default_state: Record<string, any>;
		switch ($_ui_state_group_property.properties.default_state.state.name) {
			case 'no': {
				const $_no__default_state = $_ui_state_group_property.properties.default_state.state.node;
				const raw_data: Record<string, any> = {};
				raw_default_state = raw_data
				break;
			}
			case 'yes': {
				const $_yes__default_state = $_ui_state_group_property.properties.default_state.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["default"] = serialize_ui_scalar_default($_yes__default_state.properties.default_);
				raw_default_state = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state_group_property.properties.default_state.state)
		}
		raw_data["default state"] = [$_ui_state_group_property.properties.default_state.state.name, raw_default_state];
	}
	{
		let raw_emphasis: Record<string, any>;
		switch ($_ui_state_group_property.properties.emphasis.state.name) {
			case 'no': {
				const $_no__emphasis__ui_state_group_property = $_ui_state_group_property.properties.emphasis.state.node;
				const raw_data: Record<string, any> = {};
				raw_emphasis = raw_data
				break;
			}
			case 'yes': {
				const $_yes__emphasis__ui_state_group_property = $_ui_state_group_property.properties.emphasis.state.node;
				const raw_data: Record<string, any> = {};
				raw_emphasis = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state_group_property.properties.emphasis.state)
		}
		raw_data["emphasis"] = [$_ui_state_group_property.properties.emphasis.state.name, raw_emphasis];
	}
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_state_group_property.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_state_group_property = $_ui_state_group_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_state_group_property = $_ui_state_group_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_state_group_property.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state_group_property.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_state_group_property.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_icon: Record<string, any>;
		switch ($_ui_state_group_property.properties.icon.state.name) {
			case 'no': {
				const $_no__icon__ui_state_group_property = $_ui_state_group_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_icon = raw_data
				break;
			}
			case 'yes': {
				const $_yes__icon__ui_state_group_property = $_ui_state_group_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_yes__icon__ui_state_group_property.properties.name;
				raw_icon = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_state_group_property.properties.icon.state)
		}
		raw_data["icon"] = [$_ui_state_group_property.properties.icon.state.name, raw_icon];
	}
	return raw_data;
}
function serialize_ui_style($_ui_style: read_api.Cui_style) {
	const raw_data: Record<string, any> = {};
	{
		let raw_style: Record<string, any>;
		switch ($_ui_style.properties.style.state.name) {
			case 'accent': {
				const $_accent = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			case 'background': {
				const $_background = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			case 'brand': {
				const $_brand = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			case 'error': {
				const $_error = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			case 'foreground': {
				const $_foreground = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			case 'link': {
				const $_link = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			case 'success': {
				const $_success = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			case 'warning': {
				const $_warning = $_ui_style.properties.style.state.node;
				const raw_data: Record<string, any> = {};
				raw_style = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_style.properties.style.state)
		}
		raw_data["style"] = [$_ui_style.properties.style.state.name, raw_style];
	}
	return raw_data;
}
function serialize_ui_text_property($_ui_text_property: read_api.Cui_text_property) {
	const raw_data: Record<string, any> = {};
	raw_data["classification"] = serialize_ui_property_classification($_ui_text_property.properties.classification);
	{
		let raw_default_value: Record<string, any>;
		switch ($_ui_text_property.properties.default_value.state.name) {
			case 'no': {
				const $_no__default_value = $_ui_text_property.properties.default_value.state.node;
				const raw_data: Record<string, any> = {};
				raw_default_value = raw_data
				break;
			}
			case 'yes': {
				const $_yes__default_value = $_ui_text_property.properties.default_value.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["default"] = serialize_ui_scalar_default($_yes__default_value.properties.default_);
				raw_default_value = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.default_value.state)
		}
		raw_data["default value"] = [$_ui_text_property.properties.default_value.state.name, raw_default_value];
	}
	{
		let raw_emphasis: Record<string, any>;
		switch ($_ui_text_property.properties.emphasis.state.name) {
			case 'no': {
				const $_no__emphasis__ui_text_property = $_ui_text_property.properties.emphasis.state.node;
				const raw_data: Record<string, any> = {};
				raw_emphasis = raw_data
				break;
			}
			case 'yes': {
				const $_yes__emphasis__ui_text_property = $_ui_text_property.properties.emphasis.state.node;
				const raw_data: Record<string, any> = {};
				raw_emphasis = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.emphasis.state)
		}
		raw_data["emphasis"] = [$_ui_text_property.properties.emphasis.state.name, raw_emphasis];
	}
	{
		let raw_has_custom_identifying_properties: Record<string, any>;
		switch ($_ui_text_property.properties.has_custom_identifying_properties.state.name) {
			case 'no': {
				const $_no__has_custom_identifying_properties = $_ui_text_property.properties.has_custom_identifying_properties.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_custom_identifying_properties = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_custom_identifying_properties = $_ui_text_property.properties.has_custom_identifying_properties.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["selection"] = serialize_ui_identifying_property_selection($_yes__has_custom_identifying_properties.properties.selection);
				raw_has_custom_identifying_properties = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.has_custom_identifying_properties.state)
		}
		raw_data["has custom identifying properties"] = [$_ui_text_property.properties.has_custom_identifying_properties.state.name, raw_has_custom_identifying_properties];
	}
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_text_property.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_text_property = $_ui_text_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_text_property = $_ui_text_property.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_text_property.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_text_property.properties.has_description.state.name, raw_has_description];
	}
	{
		let raw_has_validation: Record<string, any>;
		switch ($_ui_text_property.properties.has_validation.state.name) {
			case 'no': {
				const $_no__has_validation__ui_text_property = $_ui_text_property.properties.has_validation.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_validation = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_validation__ui_text_property = $_ui_text_property.properties.has_validation.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["rules"] = serialize_ui_text_validation($_yes__has_validation__ui_text_property.properties.rules);
				raw_has_validation = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.has_validation.state)
		}
		raw_data["has validation"] = [$_ui_text_property.properties.has_validation.state.name, raw_has_validation];
	}
	{
		let raw_icon: Record<string, any>;
		switch ($_ui_text_property.properties.icon.state.name) {
			case 'no': {
				const $_no__icon__ui_text_property = $_ui_text_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_icon = raw_data
				break;
			}
			case 'yes': {
				const $_yes__icon__ui_text_property = $_ui_text_property.properties.icon.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_yes__icon__ui_text_property.properties.name;
				raw_icon = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.icon.state)
		}
		raw_data["icon"] = [$_ui_text_property.properties.icon.state.name, raw_icon];
	}
	{
		let raw_is_label: Record<string, any>;
		switch ($_ui_text_property.properties.is_label.state.name) {
			case 'no': {
				const $_no__is_label = $_ui_text_property.properties.is_label.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_label = raw_data
				break;
			}
			case 'yes': {
				const $_yes__is_label = $_ui_text_property.properties.is_label.state.node;
				const raw_data: Record<string, any> = {};
				raw_is_label = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.is_label.state)
		}
		raw_data["is label"] = [$_ui_text_property.properties.is_label.state.name, raw_is_label];
	}
	{
		let raw_type: Record<string, any>;
		switch ($_ui_text_property.properties.type.state.name) {
			case 'color': {
				const $_color = $_ui_text_property.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'default': {
				const $_default = $_ui_text_property.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'html': {
				const $_html = $_ui_text_property.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'markdown': {
				const $_markdown = $_ui_text_property.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'multi-line': {
				const $_multi_line = $_ui_text_property.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			case 'url': {
				const $_url = $_ui_text_property.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_text_property.properties.type.state)
		}
		raw_data["type"] = [$_ui_text_property.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_ui_text_validation($_ui_text_validation: read_api.Cui_text_validation) {
	const raw_data: Record<string, any> = {};
	raw_data["regular expression"] = $_ui_text_validation.properties.regular_expression;
	return raw_data;
}
function serialize_ui_todo($_ui_todo: read_api.Cui_todo) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_description: Record<string, any>;
		switch ($_ui_todo.properties.has_description.state.name) {
			case 'no': {
				const $_no__has_description__ui_todo = $_ui_todo.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_description = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_description__ui_todo = $_ui_todo.properties.has_description.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["description"] = $_yes__has_description__ui_todo.properties.description;
				raw_has_description = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_ui_todo.properties.has_description.state)
		}
		raw_data["has description"] = [$_ui_todo.properties.has_description.state.name, raw_has_description];
	}
	return raw_data;
}
function serialize_unary_number_expression($_unary_number_expression: read_api.Cunary_number_expression) {
	const raw_data: Record<string, any> = {};
	raw_data["expression"] = serialize_derivation_expression_tail($_unary_number_expression.properties.expression);
	return raw_data;
}
function serialize_user_initializer($_user_initializer: read_api.Cuser_initializer) {
	const raw_data: Record<string, any> = {};
	raw_data["initializer"] = serialize_command_object_expression($_user_initializer.properties.initializer);
	return raw_data;
}
function serialize_user_requirement($_user_requirement: read_api.Cuser_requirement) {
	const raw_data: Record<string, any> = {};
	raw_data["expression"] = serialize_node_expression($_user_requirement.properties.expression);
	{
		let raw_has_alternative: Record<string, any>;
		switch ($_user_requirement.properties.has_alternative.state.name) {
			case 'no': {
				const $_no__has_alternative = $_user_requirement.properties.has_alternative.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_alternative = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_alternative = $_user_requirement.properties.has_alternative.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["alternative"] = serialize_user_requirement($_yes__has_alternative.properties.alternative);
				raw_has_alternative = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_user_requirement.properties.has_alternative.state)
		}
		raw_data["has alternative"] = [$_user_requirement.properties.has_alternative.state.name, raw_has_alternative];
	}
	{
		let raw_has_filter: Record<string, any>;
		switch ($_user_requirement.properties.has_filter.state.name) {
			case 'no': {
				const $_no__has_filter = $_user_requirement.properties.has_filter.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_filter = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_filter = $_user_requirement.properties.has_filter.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["assignment"] = serialize_optional_variable_assignment($_yes__has_filter.properties.assignment);
				raw_data["path"] = serialize_user_requirement($_yes__has_filter.properties.path);
				raw_has_filter = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_user_requirement.properties.has_filter.state)
		}
		raw_data["has filter"] = [$_user_requirement.properties.has_filter.state.name, raw_has_filter];
	}
	return raw_data;
}
function serialize_variable_assignment($_variable_assignment: read_api.Cvariable_assignment) {
	const raw_data: Record<string, any> = {};
	{
		let raw_name: Record<string, any>;
		switch ($_variable_assignment.properties.name.state.name) {
			case 'explicit': {
				const $_explicit__name__variable_assignment = $_variable_assignment.properties.name.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["name"] = $_explicit__name__variable_assignment.properties.name.entry;
				const raw_named_objects: Record<string, any> = {};
				for (let [k,v] of $_explicit__name__variable_assignment.properties.named_objects) {
					const $_named_objects__explicit__name__variable_assignment = v;
					const raw_data: Record<string, any> = {};
					{
						let raw_has_successor: Record<string, any>;
						switch ($_named_objects__explicit__name__variable_assignment.properties.has_successor.state.name) {
							case 'no': {
								const $_no__has_successor__named_objects__explicit__name__variable_assignment = $_named_objects__explicit__name__variable_assignment.properties.has_successor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_successor = raw_data
								break;
							}
							case 'yes': {
								const $_yes__has_successor__named_objects__explicit__name__variable_assignment = $_named_objects__explicit__name__variable_assignment.properties.has_successor.state.node;
								const raw_data: Record<string, any> = {};
								raw_has_successor = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_named_objects__explicit__name__variable_assignment.properties.has_successor.state)
						}
						raw_data["has successor"] = [$_named_objects__explicit__name__variable_assignment.properties.has_successor.state.name, raw_has_successor];
					}
					raw_named_objects[k] = raw_data
				}
				raw_data["named objects"] = raw_named_objects;
				raw_name = raw_data
				break;
			}
			case 'implicit': {
				const $_implicit__name__variable_assignment = $_variable_assignment.properties.name.state.node;
				const raw_data: Record<string, any> = {};
				raw_name = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_variable_assignment.properties.name.state)
		}
		raw_data["name"] = [$_variable_assignment.properties.name.state.name, raw_name];
	}
	return raw_data;
}
function serialize_variablized_object_path($_variablized_object_path: read_api.Cvariablized_object_path) {
	const raw_data: Record<string, any> = {};
	raw_data["head"] = serialize_context_object_step($_variablized_object_path.properties.head);
	raw_data["path"] = serialize_object_path_tail($_variablized_object_path.properties.path);
	return raw_data;
}
function serialize_where_rule_object_path($_where_rule_object_path: read_api.Cwhere_rule_object_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_context: Record<string, any>;
		switch ($_where_rule_object_path.properties.context.state.name) {
			case 'sibling rule': {
				const $_sibling_rule = $_where_rule_object_path.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["rule"] = $_sibling_rule.properties.rule.entry;
				raw_context = raw_data
				break;
			}
			case 'this': {
				const $_this__context__where_rule_object_path = $_where_rule_object_path.properties.context.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["head"] = serialize_context_object_step($_this__context__where_rule_object_path.properties.head);
				raw_context = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_where_rule_object_path.properties.context.state)
		}
		raw_data["context"] = [$_where_rule_object_path.properties.context.state.name, raw_context];
	}
	raw_data["path"] = serialize_object_path_tail($_where_rule_object_path.properties.path);
	return raw_data;
}
function serialize_where_rule_step($_where_rule_step: read_api.Cwhere_rule_step) {
	const raw_data: Record<string, any> = {};
	raw_data["rule"] = $_where_rule_step.properties.rule.entry;
	return raw_data;
}
function serialize_where_rules_definition($_where_rules_definition: read_api.Cwhere_rules_definition) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_rule: Record<string, any>;
		switch ($_where_rules_definition.properties.has_rule.state.name) {
			case 'no': {
				const $_no__has_rule = $_where_rules_definition.properties.has_rule.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_rule = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_rule = $_where_rules_definition.properties.has_rule.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["first"] = $_yes__has_rule.properties.first.entry;
				raw_has_rule = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_where_rules_definition.properties.has_rule.state)
		}
		raw_data["has rule"] = [$_where_rules_definition.properties.has_rule.state.name, raw_has_rule];
	}
	const raw_rules: Record<string, any> = {};
	for (let [k,v] of $_where_rules_definition.properties.rules) {
		const $_rules = v;
		const raw_data: Record<string, any> = {};
		raw_data["behaviour"] = serialize_reference_behaviour($_rules.properties.behaviour);
		raw_data["direction"] = serialize_direction_annotation($_rules.properties.direction);
		{
			let raw_has_predecessor: Record<string, any>;
			switch ($_rules.properties.has_predecessor.state.name) {
				case 'no': {
					const $_no__has_predecessor__rules = $_rules.properties.has_predecessor.state.node;
					const raw_data: Record<string, any> = {};
					raw_has_predecessor = raw_data
					break;
				}
				case 'yes': {
					const $_yes__has_predecessor__rules = $_rules.properties.has_predecessor.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["rule"] = $_yes__has_predecessor__rules.properties.rule.entry;
					raw_has_predecessor = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_rules.properties.has_predecessor.state)
			}
			raw_data["has predecessor"] = [$_rules.properties.has_predecessor.state.name, raw_has_predecessor];
		}
		raw_data["recursion"] = serialize_recursion_annotation($_rules.properties.recursion);
		{
			let raw_type: Record<string, any>;
			switch ($_rules.properties.type.state.name) {
				case 'entry reference': {
					const $_entry_reference = $_rules.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["expression"] = serialize_entry_reference_definition($_entry_reference.properties.expression);
					raw_type = raw_data
					break;
				}
				case 'node reference': {
					const $_node_reference = $_rules.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["object path"] = serialize_where_rule_object_path($_node_reference.properties.object_path);
					{
						let raw_type: Record<string, any>;
						switch ($_node_reference.properties.type.state.name) {
							case 'containment': {
								const $_containment__type__node_reference = $_node_reference.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["key node path"] = serialize_where_rule_object_path($_containment__type__node_reference.properties.key_node_path);
								raw_type = raw_data
								break;
							}
							case 'equality': {
								const $_equality__type__node_reference = $_node_reference.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["node path"] = serialize_where_rule_object_path($_equality__type__node_reference.properties.node_path);
								raw_type = raw_data
								break;
							}
							case 'existence': {
								const $_existence__type__node_reference = $_node_reference.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_node_reference.properties.type.state)
						}
						raw_data["type"] = [$_node_reference.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_rules.properties.type.state)
			}
			raw_data["type"] = [$_rules.properties.type.state.name, raw_type];
		}
		raw_data["ui"] = serialize_ui_reference_rule($_rules.properties.ui);
		raw_rules[k] = raw_data
	}
	raw_data["rules"] = raw_rules;
	return raw_data;
}
export function serialize($_application: read_api.Capplication) {
	const raw_data: Record<string, any> = {};
	{
		let raw_allow_anonymous_user: Record<string, any>;
		switch ($_application.properties.allow_anonymous_user.state.name) {
			case 'no': {
				const $_no__allow_anonymous_user = $_application.properties.allow_anonymous_user.state.node;
				const raw_data: Record<string, any> = {};
				raw_allow_anonymous_user = raw_data
				break;
			}
			case 'yes': {
				const $_yes__allow_anonymous_user = $_application.properties.allow_anonymous_user.state.node;
				const raw_data: Record<string, any> = {};
				raw_allow_anonymous_user = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_application.properties.allow_anonymous_user.state)
		}
		raw_data["allow anonymous user"] = [$_application.properties.allow_anonymous_user.state.name, raw_allow_anonymous_user];
	}
	{
		let raw_has_dynamic_users: Record<string, any>;
		switch ($_application.properties.has_dynamic_users.state.name) {
			case 'no': {
				const $_no__has_dynamic_users = $_application.properties.has_dynamic_users.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_dynamic_users = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_dynamic_users = $_application.properties.has_dynamic_users.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_has_external_authentication: Record<string, any>;
					switch ($_yes__has_dynamic_users.properties.has_external_authentication.state.name) {
						case 'no': {
							const $_no__has_external_authentication = $_yes__has_dynamic_users.properties.has_external_authentication.state.node;
							const raw_data: Record<string, any> = {};
							raw_has_external_authentication = raw_data
							break;
						}
						case 'yes': {
							const $_yes__has_external_authentication = $_yes__has_dynamic_users.properties.has_external_authentication.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["authorities path"] = serialize_descendant_base_property_path($_yes__has_external_authentication.properties.authorities_path);
							raw_data["identities path"] = serialize_descendant_base_property_path($_yes__has_external_authentication.properties.identities_path);
							raw_data["identity initializer"] = serialize_identity_initializer($_yes__has_external_authentication.properties.identity_initializer);
							raw_data["user reference"] = $_yes__has_external_authentication.properties.user_reference.entry;
							raw_has_external_authentication = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_dynamic_users.properties.has_external_authentication.state)
					}
					raw_data["has external authentication"] = [$_yes__has_dynamic_users.properties.has_external_authentication.state.name, raw_has_external_authentication];
				}
				{
					let raw_has_password_authentication: Record<string, any>;
					switch ($_yes__has_dynamic_users.properties.has_password_authentication.state.name) {
						case 'no': {
							const $_no__has_password_authentication = $_yes__has_dynamic_users.properties.has_password_authentication.state.node;
							const raw_data: Record<string, any> = {};
							raw_has_password_authentication = raw_data
							break;
						}
						case 'yes': {
							const $_yes__has_password_authentication = $_yes__has_dynamic_users.properties.has_password_authentication.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["password initializer"] = serialize_password_initializer($_yes__has_password_authentication.properties.password_initializer);
							let raw_password_status: Record<string, any>;
							{
								const $_password_status = $_yes__has_password_authentication.properties.password_status;
								const raw_data: Record<string, any> = {};
								const raw_cases: Record<string, any> = {};
								for (let [k,v] of $_password_status.properties.cases) {
									const $_cases__password_status = v;
									const raw_data: Record<string, any> = {};
									raw_data["initializer"] = serialize_command_object_expression($_cases__password_status.properties.initializer);
									raw_data["state"] = $_cases__password_status.properties.state.entry;
									raw_cases[k] = raw_data
								}
								raw_data["cases"] = raw_cases;
								raw_data["state group path"] = serialize_descendant_base_property_path($_password_status.properties.state_group_path);
								raw_password_status = raw_data
							}
							raw_data["password status"] = raw_password_status;
							raw_data["password text path"] = serialize_descendant_base_property_path($_yes__has_password_authentication.properties.password_text_path);
							raw_data["passwords collection path"] = serialize_descendant_base_property_path($_yes__has_password_authentication.properties.passwords_collection_path);
							raw_has_password_authentication = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_dynamic_users.properties.has_password_authentication.state)
					}
					raw_data["has password authentication"] = [$_yes__has_dynamic_users.properties.has_password_authentication.state.name, raw_has_password_authentication];
				}
				{
					let raw_supports_user_sign_up: Record<string, any>;
					switch ($_yes__has_dynamic_users.properties.supports_user_sign_up.state.name) {
						case 'no': {
							const $_no__supports_user_sign_up = $_yes__has_dynamic_users.properties.supports_user_sign_up.state.node;
							const raw_data: Record<string, any> = {};
							raw_supports_user_sign_up = raw_data
							break;
						}
						case 'yes': {
							const $_yes__supports_user_sign_up = $_yes__has_dynamic_users.properties.supports_user_sign_up.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["user initializer"] = serialize_user_initializer($_yes__supports_user_sign_up.properties.user_initializer);
							raw_supports_user_sign_up = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_dynamic_users.properties.supports_user_sign_up.state)
					}
					raw_data["supports user sign-up"] = [$_yes__has_dynamic_users.properties.supports_user_sign_up.state.name, raw_supports_user_sign_up];
				}
				raw_data["users collection path"] = serialize_descendant_base_property_path($_yes__has_dynamic_users.properties.users_collection_path);
				raw_has_dynamic_users = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_application.properties.has_dynamic_users.state)
		}
		raw_data["has dynamic users"] = [$_application.properties.has_dynamic_users.state.name, raw_has_dynamic_users];
	}
	const raw_imported_interfaces: Record<string, any> = {};
	for (let [k,v] of $_application.properties.imported_interfaces) {
		const $_imported_interfaces = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_connection_status: Record<string, any>;
			switch ($_imported_interfaces.properties.connection_status.state.name) {
				case 'no': {
					const $_no__connection_status = $_imported_interfaces.properties.connection_status.state.node;
					const raw_data: Record<string, any> = {};
					raw_connection_status = raw_data
					break;
				}
				case 'yes': {
					const $_yes__connection_status = $_imported_interfaces.properties.connection_status.state.node;
					const raw_data: Record<string, any> = {};
					const raw_cases: Record<string, any> = {};
					for (let [k,v] of $_yes__connection_status.properties.cases) {
						const $_cases__yes__connection_status = v;
						const raw_data: Record<string, any> = {};
						{
							let raw_dataset_status: Record<string, any>;
							switch ($_cases__yes__connection_status.properties.dataset_status.state.name) {
								case 'no': {
									const $_no__dataset_status = $_cases__yes__connection_status.properties.dataset_status.state.node;
									const raw_data: Record<string, any> = {};
									raw_dataset_status = raw_data
									break;
								}
								case 'yes': {
									const $_yes__dataset_status = $_cases__yes__connection_status.properties.dataset_status.state.node;
									const raw_data: Record<string, any> = {};
									const raw_cases: Record<string, any> = {};
									for (let [k,v] of $_yes__dataset_status.properties.cases) {
										const $_cases__yes__dataset_status = v;
										const raw_data: Record<string, any> = {};
										raw_data["initializer"] = serialize_command_object_expression($_cases__yes__dataset_status.properties.initializer);
										raw_data["state"] = $_cases__yes__dataset_status.properties.state.entry;
										raw_cases[k] = raw_data
									}
									raw_data["cases"] = raw_cases;
									raw_data["state group path"] = serialize_descendant_base_property_path($_yes__dataset_status.properties.state_group_path);
									raw_dataset_status = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_cases__yes__connection_status.properties.dataset_status.state)
							}
							raw_data["dataset status"] = [$_cases__yes__connection_status.properties.dataset_status.state.name, raw_dataset_status];
						}
						raw_data["initializer"] = serialize_command_object_expression($_cases__yes__connection_status.properties.initializer);
						raw_data["state"] = $_cases__yes__connection_status.properties.state.entry;
						raw_cases[k] = raw_data
					}
					raw_data["cases"] = raw_cases;
					raw_data["state group path"] = serialize_descendant_base_property_path($_yes__connection_status.properties.state_group_path);
					raw_connection_status = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_imported_interfaces.properties.connection_status.state)
			}
			raw_data["connection status"] = [$_imported_interfaces.properties.connection_status.state.name, raw_connection_status];
		}
		{
			let raw_instances: Record<string, any>;
			switch ($_imported_interfaces.properties.instances.state.name) {
				case 'many': {
					const $_many__instances = $_imported_interfaces.properties.instances.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["initializer"] = serialize_interface_instance_initializer($_many__instances.properties.initializer);
					raw_instances = raw_data
					break;
				}
				case 'one': {
					const $_one__instances = $_imported_interfaces.properties.instances.state.node;
					const raw_data: Record<string, any> = {};
					raw_instances = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_imported_interfaces.properties.instances.state)
			}
			raw_data["instances"] = [$_imported_interfaces.properties.instances.state.name, raw_instances];
		}
		const raw_parameters: Record<string, any> = {};
		for (let [k,v] of $_imported_interfaces.properties.parameters) {
			const $_parameters = v;
			const raw_data: Record<string, any> = {};
			raw_data["value"] = $_parameters.properties.value.entry;
			raw_parameters[k] = raw_data
		}
		raw_data["parameters"] = raw_parameters;
		raw_data["path"] = serialize_object_path_tail($_imported_interfaces.properties.path);
		raw_imported_interfaces[k] = raw_data
	}
	raw_data["imported interfaces"] = raw_imported_interfaces;
	const raw_numerical_types: Record<string, any> = {};
	for (let [k,v] of $_application.properties.numerical_types) {
		const $_numerical_types = v;
		const raw_data: Record<string, any> = {};
		const raw_singular_conversions: Record<string, any> = {};
		for (let [k,v] of $_numerical_types.properties.singular_conversions) {
			const $_singular_conversions = v;
			const raw_data: Record<string, any> = {};
			{
				let raw_type: Record<string, any>;
				switch ($_singular_conversions.properties.type.state.name) {
					case 'base': {
						const $_base__type__singular_conversions = $_singular_conversions.properties.type.state.node;
						const raw_data: Record<string, any> = {};
						raw_data["base"] = $_base__type__singular_conversions.properties.base.value;
						raw_data["exponent"] = $_base__type__singular_conversions.properties.exponent.value;
						raw_data["offset"] = $_base__type__singular_conversions.properties.offset.value;
						{
							let raw_unit_conversion: Record<string, any>;
							switch ($_base__type__singular_conversions.properties.unit_conversion.state.name) {
								case 'no': {
									const $_no__unit_conversion = $_base__type__singular_conversions.properties.unit_conversion.state.node;
									const raw_data: Record<string, any> = {};
									raw_unit_conversion = raw_data
									break;
								}
								case 'yes': {
									const $_yes__unit_conversion = $_base__type__singular_conversions.properties.unit_conversion.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["conversion rule"] = $_yes__unit_conversion.properties.conversion_rule.entry;
									raw_unit_conversion = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_base__type__singular_conversions.properties.unit_conversion.state)
							}
							raw_data["unit conversion"] = [$_base__type__singular_conversions.properties.unit_conversion.state.name, raw_unit_conversion];
						}
						raw_type = raw_data
						break;
					}
					case 'factor': {
						const $_factor = $_singular_conversions.properties.type.state.node;
						const raw_data: Record<string, any> = {};
						raw_data["base"] = $_factor.properties.base.value;
						raw_data["exponent"] = $_factor.properties.exponent.value;
						raw_data["factor"] = $_factor.properties.factor.value;
						{
							let raw_invert: Record<string, any>;
							switch ($_factor.properties.invert.state.name) {
								case 'no': {
									const $_no__invert = $_factor.properties.invert.state.node;
									const raw_data: Record<string, any> = {};
									raw_invert = raw_data
									break;
								}
								case 'yes': {
									const $_yes__invert = $_factor.properties.invert.state.node;
									const raw_data: Record<string, any> = {};
									raw_invert = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_factor.properties.invert.state)
							}
							raw_data["invert"] = [$_factor.properties.invert.state.name, raw_invert];
						}
						raw_type = raw_data
						break;
					}
					default:
						throw new Error("unexpected state: " + $_singular_conversions.properties.type.state)
				}
				raw_data["type"] = [$_singular_conversions.properties.type.state.name, raw_type];
			}
			raw_singular_conversions[k] = raw_data
		}
		raw_data["singular conversions"] = raw_singular_conversions;
		{
			let raw_type: Record<string, any>;
			switch ($_numerical_types.properties.type.state.name) {
				case 'quantity': {
					const $_quantity = $_numerical_types.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					const raw_division_conversions: Record<string, any> = {};
					for (let [k,v] of $_quantity.properties.division_conversions) {
						const $_division_conversions = v;
						const raw_data: Record<string, any> = {};
						raw_data["denominator"] = $_division_conversions.properties.denominator.entry;
						raw_division_conversions[k] = raw_data
					}
					raw_data["division conversions"] = raw_division_conversions;
					const raw_product_conversions: Record<string, any> = {};
					for (let [k,v] of $_quantity.properties.product_conversions) {
						const $_product_conversions = v;
						const raw_data: Record<string, any> = {};
						raw_data["right"] = $_product_conversions.properties.right.entry;
						raw_product_conversions[k] = raw_data
					}
					raw_data["product conversions"] = raw_product_conversions;
					raw_type = raw_data
					break;
				}
				case 'scale': {
					const $_scale = $_numerical_types.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["range type"] = $_scale.properties.range_type.entry;
					{
						let raw_timer_resolution: Record<string, any>;
						switch ($_scale.properties.timer_resolution.state.name) {
							case 'none': {
								const $_none__timer_resolution = $_scale.properties.timer_resolution.state.node;
								const raw_data: Record<string, any> = {};
								raw_timer_resolution = raw_data
								break;
							}
							case 'seconds': {
								const $_seconds__timer_resolution = $_scale.properties.timer_resolution.state.node;
								const raw_data: Record<string, any> = {};
								raw_timer_resolution = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_scale.properties.timer_resolution.state)
						}
						raw_data["timer resolution"] = [$_scale.properties.timer_resolution.state.name, raw_timer_resolution];
					}
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_numerical_types.properties.type.state)
			}
			raw_data["type"] = [$_numerical_types.properties.type.state.name, raw_type];
		}
		raw_data["ui"] = serialize_ui_numerical_type($_numerical_types.properties.ui);
		raw_numerical_types[k] = raw_data
	}
	raw_data["numerical types"] = raw_numerical_types;
	raw_data["root"] = serialize_node($_application.properties.root);
	return raw_data;
}